(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by noOne on 09/08/2017.
 */
var config = {
    //=========================================================================================================//
    //=========================================================================================================//

    //--how long the course starts at--//
    "basicLength": 50000,

    //--random extra length to add to this--//
    "randomLength": 2,

    //--random variation for distance between obstacles--//
    "randomObsDist": 200,

    //--minimum cannon back rotation--//
    "minCannonRot": -1,

    //--total number of stars (note they get recycled)--//
    "numStars": 100,

    //--total number of obstacles (again, they get recycled so no need to set it too high)--//
    "numObs": 15,

    //--total balloons (recycled as well but if you turn this up you will get lots of balloons to bounce off)--//
    "numBalloons": 5,

    //=========================================================================================================//
    //=========================================================================================================//

    //--max x velocity (prevents happo reaching light speed)--//
    "maxDx": 100,

    //--boost force--//
    "boostPower": 50,

    //--force of gravity (make sure its negative otherwise happo will fall upwards)--//
    "gravity": -1.4,

    //--how hard bouncing pushes the player forward (could probably
    // be negative and object bounces would slow the player--//
    "bouncePushForward": 5,

    //--how much bounce you get from objects--//
    "yBounceFactor": 2.5,

    //=========================================================================================================//
    //==As long as a texture name, sound name and bounce factor is provided any new objects added should work==//
    //=========================================================================================================//
    /**
     * how bouncy each individual object is
     */
    "bounceFactors": {
        "beach_ball": 30,
        "bucket": 22,
        "hammock": 25,
        "parasol": 35,
        "trampoline": 40,
        "tub": 25,
        "yoga_ball": 25,
        "none": 20,
        "pit": 6,
        "spring": 35,
        "spring_2": 40,
        "float": 35,
        "drumm": 25,
        "deck_chair_1": 25,
        "balloons": 35
    },

    //--obj texture names--//
    "objTextures": {
        0: "beach_ball",
        1: "bucket",
        2: "hammock",
        3: "parasol",
        4: "trampoline",
        5: "tub",
        6: "yoga_ball",
        7: "spring",
        8: "float",
        9: "drumm",
        10: "deck_chair_1",
        11: "spring_2"
    },

    //--obj sound names--//
    "sounds": {
        "beach_ball": "sfx_bounce_yogaball_00",
        "bucket": "sfx_bounce_bucket_00",
        "hammock": "sfx_bounce_hammock_00",
        "parasol": "sfx_bounce_plastic_00",
        "trampoline": "sfx_bounce_trampoline_00",
        "tub": "sfx_bounce_plastic_00",
        "yoga_ball": "sfx_bounce_yogaball_00",
        "none": "sfx_happo_impact_00",
        "spring": "sfx_bounce_springboard_00",
        "spring_2": "sfx_bounce_springboard_00",
        "float": "sfx_bounce_plastic_00",
        "drumm": "sfx_bounce_drum_00",
        "deck_chair_1": "sfx_bounce_hammock_00",
        "balloons": "sfx_bounce_plastic_00"
    }
};

exports.default = config;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _SplashScene = require("./SplashScene");

var _SplashScene2 = _interopRequireDefault(_SplashScene);

var _ResultsScene = require("./ResultsScene");

var _ResultsScene2 = _interopRequireDefault(_ResultsScene);

var _GameScene = require("./GameScene");

var _GameScene2 = _interopRequireDefault(_GameScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Application = function () {
    function Application() {
        _classCallCheck(this, Application);

        _Common2.default.copy = _Common2.default.assets.getJSON("copy");
        //Common.config = Common.assets.getJSON("config");
    }

    _createClass(Application, [{
        key: "init",
        value: function init() {
            this.showSplashScene();
        }

        /**
         * @returns {Scene}
         */

    }, {
        key: "showSplashScene",
        value: function showSplashScene() {

            var scene = new _SplashScene2.default();

            scene.signals.next.add(function () {
                this.showGameScene();
            }, this);

            var transition = new p3.FadeTransition(0x0, 1.0);
            _Common2.default.scene.add(scene, transition);
            return scene;
        }

        /**
         * @returns {Scene}
         */

    }, {
        key: "showResultsScene",
        value: function showResultsScene() {

            var scene = new _ResultsScene2.default();

            scene.signals.next.add(function () {
                this.showGameScene();
            }, this);

            scene.signals.home.add(function (scene) {
                this.showSplashScene();
            }, this);

            var transition = new p3.FadeTransition(0x0, 1.0);
            _Common2.default.scene.add(scene, transition);
            return scene;
        }
    }, {
        key: "showGameScene",
        value: function showGameScene() {
            _Common2.default.paused = false;

            var scene = new _GameScene2.default();

            scene.signals.previous.add(function (scene) {
                this.showGameScene();
            }, this);

            scene.signals.next.add(function (scene) {
                this.showResultsScene();
            }, this);

            scene.signals.home.add(function (scene) {
                this.showSplashScene();
            }, this);

            var transition = new p3.FadeTransition(0x0, 1.0);
            _Common2.default.scene.add(scene, transition);
            return scene;
        }
    }]);

    return Application;
}();

exports.default = Application;

},{"./Common":6,"./GameScene":7,"./ResultsScene":9,"./SplashScene":10}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AudioParams = require("./AudioParams");

var _AudioParams2 = _interopRequireDefault(_AudioParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AudioManager = function () {
    function AudioManager() {
        _classCallCheck(this, AudioManager);

        /**
         * @type {object}
         * @private
         */
        this._cache = {};

        /**
         * @type {Howl}
         * @private
         */
        this._music = null;

        /**
         * @type {boolean}
         * @private
         */
        this._isMuted = false;

        /**
         *
         * @type {boolean}
         * @private
         */
        this._isMute = false;

        var hidden;
        "undefined" != typeof document.hidden ? (hidden = "hidden", this.visibilityChange = "visibilitychange") : "undefined" != typeof document.mozHidden ? (hidden = "mozHidden", this.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.msHidden ? (hidden = "msHidden", this.visibilityChange = "msvisibilitychange") : "undefined" != typeof document.webkitHidden && (hidden = "webkitHidden", this.visibilityChange = "webkitvisibilitychange");

        //var that = this;
        document.addEventListener(this.visibilityChange, function () {
            document[hidden] ? Howler.volume(0) : Howler.volume(1);
            //!document[hidden] && !that._isMuted ? Howler.volume(1) : Howler.volume(0);
            //console.log('sound updated' + that._isMuted);
        }, false);
    }

    _createClass(AudioManager, [{
        key: "addSounds",


        /**
         * @param {!Array.<string>} sounds
         * @param {!Array.<string>} extensions
         * @param {string=} basePath
         */
        value: function addSounds(sounds, extensions, basePath) {
            basePath = basePath || "";

            var howl = void 0,
                name = void 0,
                url = void 0,
                urls = void 0,
                extension = void 0,
                i = void 0,
                j = void 0;
            for (i = 0; i < sounds.length; ++i) {
                url = basePath + sounds[i];
                url = url.split("/");
                name = url[url.length - 1];

                urls = [];
                for (j = 0; j < extensions.length; ++j) {
                    extension = extensions[j];
                    urls.push(url.join("/") + extension);
                }
                howl = new Howl({
                    src: urls,
                    volume: 1.0,
                    loop: false,
                    autoplay: false,
                    onloaderror: function onloaderror() {
                        console.warn("Error loading sound - " + name);
                    }
                });
                howl.name = name;
                this._cache[name] = howl;
            }
        }

        /**
         * @param {!Array.<string>} sounds
         */

    }, {
        key: "removeSounds",
        value: function removeSounds(sounds) {
            var name, n, howl;
            for (var i = 0; i < sounds.length; ++i) {
                name = sounds[i];
                for (n in this._cache) {
                    if (this._cache.hasOwnProperty(key)) {
                        howl = this._cache[key];
                        if (howl.name == n) {
                            howl.unload();
                            delete this._cache[name];
                            break;
                        }
                    }
                }
            }
        }

        /**
         * @param {!string | Array.<string>} name
         * @param {AudioParams=} params
         */

    }, {
        key: "playSound",
        value: function playSound(name, params) {
            params = params || new _AudioParams2.default();

            if (typeof name !== "string") {
                name = name[Math.floor(Math.random() * name.length)];
            }

            var howl = this._cache[name];
            if (!howl) {
                console.warn("could not find sound : " + name);
                return null;
            }

            howl.volume(params.volume);
            howl.loop(params.loop);

            // todo sound callback
            if (params.onEnd) {
                howl.on("end", params.onEnd);
            }

            if (p3.Device && p3.Device.isAndroidStockBrowser) {
                howl.buffer = true;
            }

            if (params.fadeIn > 0.0) {
                this.fadeIn(howl, params.fadeIn);
            } else {
                howl.play();
            }
            return howl;
        }
    }, {
        key: "playMusic",
        value: function playMusic(name, params) {
            params = params || new _AudioParams2.default();

            if (typeof name !== "string") {
                name = name[Math.floor(Math.random() * name.length)];
            }

            // skip if no change
            if (this._music && this._music.name == name) {
                return this._music;
            }

            var howl = this._cache[name];
            if (!howl) {
                console.warn("Could not find music - " + name);
                return null;
            }

            howl.volume(params.volume);
            howl.loop(true);

            // callback
            howl.__onend = function () {
                params.callback && params.callback.call(params.scope);
            };
            howl.on("end", howl.__onend);

            if (params.loopStart) {
                // howl._start = params.loopStart;
            }
            if (params.loopEnd) {
                // howl._end = params.loopEnd;
            }

            if (p3.Device && p3.Device.isAndroidStockBrowser) {
                howl.buffer = true;
            }

            if (params.fadeIn > 0.0) {
                if (this._music && this._music.name != name) {
                    this.fadeOut(this._music, params.fadeIn, function (howl) {
                        howl.stop();
                    }, this);
                }
                this.fadeIn(howl, params.fadeIn);
            } else {
                this._music && this.stopMusic();
                howl.play();
            }
            this._music = howl;
            return howl;
        }

        /**
         * @param {!string} name
         */

    }, {
        key: "stopSound",
        value: function stopSound(name) {
            var howl;
            for (var n in this._cache) {
                if (this._cache.hasOwnProperty(n)) {
                    howl = this._cache[n];
                    if (howl.name == name) {
                        howl.stop();
                        break;
                    }
                }
            }
        }

        /**
         *
         * @param name
         */

    }, {
        key: "stopMusic",
        value: function stopMusic(name) {
            name = name || this._music.name;
            if (this._music && this._music.name == name) {
                this._music.__onend && this._music.off("end", this._music.__onend);
                this._music.stop();
                this._music = null;
            }
        }
    }, {
        key: "mute",
        value: function mute(value) {
            this._isMuted = value;
            if (this._isMuted) {
                Howler.mute(true);
            } else {
                Howler.mute(false);
            }
        }

        /**
         *
         * @param howl
         * @param duration
         * @param callback
         * @param scope
         */

    }, {
        key: "fadeIn",
        value: function fadeIn(howl, duration, callback, scope) {
            duration = duration || 1.0;
            howl.volume(0.0);
            howl.play();
            howl.__volume = howl._volume;

            TweenMax.killTweensOf(howl);
            TweenMax.to(howl, duration, {
                __volume: 1.0,
                ease: Power1.easeInOut,
                onUpdate: function onUpdate() {
                    howl.volume(howl.__volume);
                },
                onUpdateScope: this,
                onComplete: callback,
                onCompleteParams: [howl],
                onCompleteScope: scope
            });
        }
    }, {
        key: "fadeOut",
        value: function fadeOut(howl, duration, callback, scope) {
            duration = duration || 1.0;
            howl.__volume = howl._volume;

            TweenMax.killTweensOf(howl);
            TweenMax.to(howl, duration, {
                __volume: 0.0,
                ease: Power1.easeInOut,
                onUpdate: function onUpdate() {
                    howl.volume(howl.__volume);
                },
                onUpdateScope: this,
                onComplete: callback,
                onCompleteParams: [howl],
                onCompleteScope: scope
            });
        }
    }, {
        key: "isMute",
        get: function get() {
            return this._isMute;
        }
    }]);

    return AudioManager;
}();

exports.default = AudioManager;

},{"./AudioParams":4}],4:[function(require,module,exports){
/**
 *  AudioParams
 *  Created by Legman on 25/02/2016.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AudioParams = function () {
    function AudioParams() {
        _classCallCheck(this, AudioParams);

        /**
         * @type {number}
         */
        this._volume = 1.0;

        /**
         * @type {boolean}
         */
        this._loop = false;

        /**
         * @type {number}
         */
        this._delay = 0.0;

        /**
         * @type {number}
         */
        this._fadeIn = 0.0;

        /**
         * @type {number}
         */
        this._priority = 0;

        /**
         * @type {function}
         */
        this._callback = null;

        /**
         * @type {*}
         */
        this._scope = window;
    }

    _createClass(AudioParams, [{
        key: "volume",
        get: function get() {
            return this._volume;
        },
        set: function set(val) {
            this._volume = val;
        }
    }, {
        key: "loop",
        get: function get() {
            return this._loop;
        },
        set: function set(val) {
            this._loop = val;
        }
    }, {
        key: "delay",
        get: function get() {
            return this._delay;
        },
        set: function set(val) {
            this._delay = val;
        }
    }, {
        key: "fadeIn",
        get: function get() {
            return this._fadeIn;
        },
        set: function set(val) {
            this._fadeIn = val;
        }
    }, {
        key: "priority",
        get: function get() {
            return this._priority;
        },
        set: function set(val) {
            this._priority = val;
        }
    }, {
        key: "callback",
        get: function get() {
            return this._callback;
        },
        set: function set(val) {
            this._callback = val;
        }
    }, {
        key: "scope",
        get: function get() {
            return this._scope;
        }
    }]);

    return AudioParams;
}();

exports.default = AudioParams;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var that;

var Button = function (_p3$Button) {
    _inherits(Button, _p3$Button);

    /**
     * @param states
     * @param scope
     * @param audioType
     */
    function Button(states, scope, audioType) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, states));

        that = scope;
        _this.type = audioType || "fwd";

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._normal = new PIXI.Sprite(states.normal || PIXI.Texture.EMPTY);
        _this._normal.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(_this._normal);
        _this._normal.visible = false;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._over = new PIXI.Sprite(states.over || PIXI.Texture.EMPTY);
        _this._over.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(_this._over);
        _this._over.visible = false;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._down = new PIXI.Sprite(states.down || PIXI.Texture.EMPTY);
        _this._down.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(_this._down);
        _this._down.visible = false;
        return _this;
    }

    _createClass(Button, [{
        key: "onMouseOver",
        value: function onMouseOver() {
            if (!that.isMute) that.audio.playSound("sfx_btn_rollover_00");
            _get(Button.prototype.__proto__ || Object.getPrototypeOf(Button.prototype), "onMouseOver", this).call(this);
        }
    }, {
        key: "onMouseDown",
        value: function onMouseDown() {
            if (!that.isMute) {
                that.audio.playSound("sfx_btn_press_00");
            }
            _get(Button.prototype.__proto__ || Object.getPrototypeOf(Button.prototype), "onMouseDown", this).call(this);
        }
    }, {
        key: "onMouseOut",
        value: function onMouseOut() {
            _get(Button.prototype.__proto__ || Object.getPrototypeOf(Button.prototype), "onMouseOut", this).call(this);
        }
    }, {
        key: "enabled",
        get: function get() {
            return this._enabled;
        },
        set: function set(bool) {
            this._enabled = bool;
        }
    }]);

    return Button;
}(p3.Button);

exports.default = Button;

},{"./Common":6}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Button = require("./Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Common() {}
exports.default = Common;


Common.smoothie = null;

/**
 * @type {Array}
 */
Common.displayObjs = null;

/**
 * Total fly distance achieved in a game
 * @type {number}
 */
Common.flyDist = 0;

/**
 * @type {Charm}
 */
Common.charm = null;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * @type {string}
 */
Common.homeURL = "http://www.boomerangtv.co.uk/games";

/**
 * Semi unique key used as an identifier, followed by the version
 * @type {string}
 */
Common.game_key = "game_data_0lkwjtndqata_gold_v1_2";

/**
 * @type {number[]}
 */
Common.highScores = [0, 0, 0];

/**
 * @type {p3.View}
 */
Common.view = null;

/**
 * Basic physics module provides some simple functions to bounce sprites off each other etc.
 * @type {Physics}
 */
//Common.physics = null;

/**
 * @type {number}
 * @static
 * @const
 */
Common.STAGE_WIDTH = 1900;

/**
 * @type {number}
 * @static
 * @const
 */
Common.STAGE_HEIGHT = 1024;

/**
 * @type {PIXI.Container}
 * @static
 */
Common.stage = null;

/**
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 * @static
 */
Common.renderer = null;

/**
 * @type {p3.Timestep}
 * @static
 */
Common.timestep = null;

/**
 * @type {p3.Tracking}
 * @static
 */
Common.tracking = null;

/**
 * @type {AudioManager}
 * @static
 */
Common.audio = null;

/**
 * @type {p3.Camera}
 * @static
 */
Common.camera = null;

/**
 * @type {Player}
 * @static
 */
//Common.player = null;

/**
 * @type {object}
 * @static
 */
Common.copy = null;

/**
 * @type {object}
 * @static
 */
Common.config = null;

/**
 * @type {string}
 * @static
 */
Common.language = "";

/**
 * @type {PIXI.Point}
 * @static
 */
Common.touch = new PIXI.Point(0.0, 0.0);

/**
 * @type {boolean}
 * @static
 */
Common.touching = false;

/**
 * @type {number}
 * @static
 */
Common.paused = false;

/**
 * @type {boolean}
 * @static
 */
Common.isWebGL = false;

/**
 * @type {boolean}
 * @static
 */
Common.isFirstPlay = true;

/**
 * @type {boolean}
 * @static
 */
Common.debug = null;

/**
 * @type {boolean}
 * @static
 */
Common.devDebug = false;

/**
 * @type {boolean}
 * @static
 */
Common.isMute = false;

/**
 * Creates and returns a new button
 * @param x - Coordinate
 * @param y - Coordinates
 * @param type - Button type
 * @param clickFunc - Target function
 * @param scope  -This context
 * @param holder - Display container optional arg]
 * @param icon - btn icon
 * @returns {Button}
 */
Common.createButton = function (x, y, type, clickFunc, scope, holder, icon) {

    var states = new p3.ButtonStates();

    if (type === null || type === undefined) {
        states.normal = Common.assets.getTexture("pause_btn_frame");
        states.over = Common.assets.getTexture("pause_btn_frame");
    } else if (typeof type === "string") {
        states.normal = Common.assets.getTexture("btn_" + type + "_off");
        states.over = Common.assets.getTexture("btn_" + type + "_over");
        states.down = Common.assets.getTexture("btn_" + type + "_down");
    } else {
        states.normal = type;
    }

    //lil hax so forward and back sounds are assigned correctly
    var button;
    if (type == "back" || type == "close" || type == "exit" || type == "home" || type == "menu" || typeof type !== "string") {
        button = new _Button2.default(states, this);
        if (typeof type !== "string") button.compositeSprite = type;
    } else {
        button = new _Button2.default(states, this, "fwd");
    }

    button.x = x;
    button.y = y;
    button.anchor = new PIXI.Point(0.5, 0.5);
    button.animate = true;

    button.signals.click.add(clickFunc, scope);

    if (holder) holder.addChild(button);

    /*
     if (debugText) {
     let text = new PIXI.Text(debugText, {fontFamily: "Arial", fontSize: "32px"});
     text.anchor = {x: 0.5, y: 0.5};
     button.addChild(text);
     }
     */

    if (icon) {
        button.icon = new PIXI.Sprite(Common.assets.getTexture(icon));
        button.icon.anchor.set(0.5);
        button.addChild(button.icon);
    }

    return button;
};

/**
 * Knuth shuffle variation
 * @param string
 * @returns {string}
 */
Common.shuffleString = function (string) {
    var a = string.split(""); //our array
    var n = a.length; //number of elements

    for (var i = n - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
};

/**
 * Generates a random string for use as a semi unique ID for save data
 * @param strLen - Desired length of random string
 * @returns {string}
 */
Common.randomID = function (strLen) {
    return Math.random().toString(36).substr(2, strLen);
};

/**
 * Returns the angle between two points, where 0 is 3 o clock, 90 degrees is 6 o clock, etc.
 * @param x1 {number}
 * @param y1 {number}
 * @param x2 {number}
 * @param y2 {number}
 * @returns {number}
 */
Common.angle = function (x1, y1, x2, y2) {
    var dy = y2 - y1;
    var dx = x2 - x1;
    var theta = Math.atan2(dy, dx); // range (-PI, PI]
    ///theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    return theta;
};

/**
 * @param {number} x1 - Coordinate X of 1st point
 * @param {number} y1 - Coordinate Y of 1st point
 * @param {number} x2 - Coordinate X of 2nd point
 * @param {number} y2 - Coordinate Y of 2nd point
 * @returns {number} distance - Euclidean distance between the two points
 */
Common.distance = function (x1, y1, x2, y2) {
    return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
};

/**
 * @param {number} deg
 * @returns {number} rad
 */
Common.deg2rad = function (deg) {
    return deg * (Math.PI / 180);
};

Common.rad2deg = function (rad) {
    return rad *= 180 / Math.PI; // rads to degs, range (-180, 180]
};

/**
 * Uses quick sort to sort an array, with optional flag to sort high to low
 * @param array
 * @param highToLow
 * @returns {*}
 */
Common.sort = function (array, highToLow) {
    var size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {

        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }

        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first],
                index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow && array[i] < pivot) swap(index++, i);else if (highToLow && array[i] > pivot) swap(index++, i);
            }
            swap(index, last);
            return index;
        }
    }
};

/**
 * Sorts tiles (or any display object) by x, y coordinates so they are ordered lowest top to bottom , left to right
 * @param array
 * @returns {*}
 */
Common.sortTiles = function (array) {
    array.sort(function (a, b) {
        if (a.y == b.y) return a.x - b.x;
        return a.y - b.y;
    });
    return array;
};

/**
 * Uses oriented bounding box (OBB) to check collisions with optional tuning arg to make bounds bigger or smaller
 * @param r1
 * @param r2
 * @param tuner
 * @returns {boolean}
 */
Common.collisionOBB = function (r1, r2, tuner) {
    if (!tuner || tuner <= 0) tuner = 1;
    r1 = r1.getBounds();
    r2 = r2.getBounds();

    return !(r2.x > r1.x + r1.width * tuner || r2.x + r2.width * tuner < r1.x || r2.y > r1.y + r1.height * tuner || r2.y + r2.height * tuner < r1.y);
};

/**
 * Returns a new keyboard object that listens for keyboard input
 * @param keyCode
 * @returns {{}}
 */
Common.keyboard = function (keyCode) {
    var key = {};
    key.code = keyCode;
    key.isDown = false;
    key.isUp = true;
    key.down = undefined;
    key.up = undefined;
    //The `downHandler`
    key.downHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isUp && key.down) key.down();
            key.isDown = true;
            key.isUp = false;
        }
        event.preventDefault();
    };

    //The `upHandler`
    key.upHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isDown && key.up) key.up();
            key.isDown = false;
            key.isUp = true;
        }
        event.preventDefault();
    };

    //Attach event listeners
    window.addEventListener("keydown", key.downHandler.bind(key), false);
    window.addEventListener("keyup", key.upHandler.bind(key), false);
    return key;
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @returns {PIXI.Sprite|String}
 */
Common.generateRect = function (width, height, colour) {
    var g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);else g.beginFill(0x000fff);
    g.drawRect(0, 0, width, height);
    g.endFill();
    var sprite = new PIXI.Sprite(Common.renderer.generateTexture(g));
    sprite.anchor = { x: 0.5, y: 0.5 };
    g.destroy();
    return sprite;
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @param retTexture - Should we return a texture or a sprite
 * @returns {PIXI.Sprite|PIXI.Texture}
 */
Common.generateEllipse = function (width, height, colour, retTexture) {
    var g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);else g.beginFill(0xfff000);
    g.drawEllipse(0, 0, width, height);
    g.endFill();
    var texture = Common.renderer.generateTexture(g);
    var sprite = new PIXI.Sprite(texture);
    sprite.anchor = { x: 0.5, y: 0.5 };
    g.destroy();
    if (!retTexture) return sprite;else return texture;
};

/**
 * Centres all sprites passed to it
 * @param sprite
 */
Common.centreAnchor = function (sprite) {
    for (var i = 0; i < arguments.length; i++) {
        arguments[i].anchor = { x: 0.5, y: 0.5 };
    }
};

/**
 * Knuth shuffle
 * @param a
 * @returns {*}
 */
Common.shuffleArr = function (a) {
    for (var i = a.length; i; i--) {
        var j = Math.floor(Math.random() * i);
        var _ref = [a[j], a[i - 1]];
        a[i - 1] = _ref[0];
        a[j] = _ref[1];
    }
    return a;
};

/**
 * Returns a matrix of defined size with optional initial values
 * @param {number} numRows - Number rows in matrix
 * @param {number} numCols - Number of columns in matrix
 * @param initial - Optional initial value
 * @returns {Array}
 */
Common.matrix = function (numRows, numCols, initial) {
    var arr = [];
    for (var i = 0; i < numRows; i++) {
        var columns = [];
        for (var j = 0; j < numCols; j++) {
            columns[j] = initial;
        }arr[i] = columns;
    }
    return arr;
};

/**
 * Returns array of defined size with optional initial values
 * @param {number} size
 * @param initial
 * @returns {Array}
 */
Common.array = function (size, initial) {
    var arr = [];
    for (var i = 0; i < size; i++) {
        arr.push(initial);
    }return arr;
};

Common.saveGame = function () {
    var gameData = {
        highScores: Common.highScores,
        isFirstPlay: Common.isFirstPlay
    };
    localStorage.setItem(Common.game_key, JSON.stringify(gameData));
};

Common.loadGame = function () {
    //if the data exists get it
    var gameData = JSON.parse(localStorage.getItem(Common.game_key));
    if (gameData) {
        Common.highScores = gameData.highScores;
        Common.isFirstPlay = gameData.isFirstPlay;
    } // else Common.isFirstPlay = true;
};

/**
 * @param a
 * @param b
 * @returns {{x: *, y: *}}
 */
Common.vectorAdd = function (a, b) {
    return { x: a.x + b.x, y: a.y + b.y };
};

/**
 * @param a
 * @param b
 * @returns {{x: number, y: number}}
 */
Common.vectorSub = function (a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
};

/**
 * @param a
 * @param b
 * @returns {{x: number, y: number}}
 */
Common.vectorMulti = function (a, b) {
    return { x: a.x * b.x, y: a.y * b.y };
};

/**
 * @param start
 * @param end
 * @param perc - range 0...1
 * @returns {{x, y}|{x: *, y: *}}
 */
Common.lerp = function (start, end, perc) {
    // return (start + perc * (end - start));
    var endMinusStart = Common.vectorSub(end, start);
    //  console.log(endMinusStart);
    // const multiPerc = Common.vectorMulti(perc, endMinusStart);
    endMinusStart.x *= perc;
    endMinusStart.y *= perc;
    // console.log(multiPerc);
    return Common.vectorAdd(start, endMinusStart);
};

/**
 * @param x
 * @param y
 */
Common.toPercent = function (x, y) {
    return 100 * (y / x);
};

Common.lerp = function (obj, time, target, cb) {
    time *= 1000; //to ms
    var lerp = { startTime: Date.now(), obj: obj, time: time, cb: cb, target: target };
    lerp.update = function () {
        var elapsed = Date.now() - lerp.startTime;
        if (elapsed >= lerp.time) {
            if (lerp.cb) lerp.cb();
            return true;
        }
        var perc = Common.toPercent(lerp.time, elapsed) / 100;
        var updated = Common.lerp(lerp.obj, lerp.target, perc / 25);
        lerp.obj.x = updated.x;
        lerp.obj.y = updated.y;
    };
    //--lerp's should be pushed onto an array for updating--//
    //--put below in update function to update lerp's--//
    /*
     for (let i in this._lerps) {
     if (this._lerps[i].update()) {
     this._lerps[i] = null;
     delete this._lerps[i];
     this._lerps.splice(i, 1);
     }
     }
     */
    return lerp;
};

Common.getFrag = function (quality, distance) {
    return ['precision mediump float;', 'varying vec2 vTextureCoord;', 'uniform sampler2D texture;', 'uniform float distance;', 'uniform float outerStrength;', 'uniform float innerStrength;', 'uniform vec4 glowColor;', 'uniform float pixelWidth;', 'uniform float pixelHeight;', 'vec2 px = vec2(pixelWidth, pixelHeight);', 'void main(void) {', '    const float PI = 3.14159265358979323846264;', '    vec4 ownColor = texture2D(texture, vTextureCoord);', '    vec4 curColor;', '    float totalAlpha = 0.;', '    float maxTotalAlpha = 0.;', '    float cosAngle;', '    float sinAngle;', '    for (float angle = 0.; angle <= PI * 2.; angle += ' + (1 / quality / distance).toFixed(7) + ') {', '       cosAngle = cos(angle);', '       sinAngle = sin(angle);', '       for (float curDistance = 1.; curDistance <= ' + distance.toFixed(7) + '; curDistance++) {', '           curColor = texture2D(texture, vec2(vTextureCoord.x + cosAngle * curDistance * px.x, vTextureCoord.y + sinAngle * curDistance * px.y));', '           totalAlpha += (distance - curDistance) * curColor.a;', '           maxTotalAlpha += (distance - curDistance);', '       }', '    }', '    maxTotalAlpha = max(maxTotalAlpha, 0.0001);', '    ownColor.a = max(ownColor.a, 0.0001);', '    ownColor.rgb = ownColor.rgb / ownColor.a;', '    float outerGlowAlpha = (totalAlpha / maxTotalAlpha)  * outerStrength * (1. - ownColor.a);', '    float innerGlowAlpha = ((maxTotalAlpha - totalAlpha) / maxTotalAlpha) * innerStrength * ownColor.a;', '    float resultAlpha = (ownColor.a + outerGlowAlpha);', '    gl_FragColor = vec4(mix(mix(ownColor.rgb, glowColor.rgb, innerGlowAlpha / ownColor.a), glowColor.rgb, outerGlowAlpha / resultAlpha) * resultAlpha, resultAlpha);', '}'];
};

},{"./Button":5}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _config = require("../assets/data/config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//--global display array used for cleanup--//
var disp = [];

var GameScene = function (_p3$Scene) {
    _inherits(GameScene, _p3$Scene);

    function GameScene() {
        _classCallCheck(this, GameScene);

        var _this = _possibleConstructorReturn(this, (GameScene.__proto__ || Object.getPrototypeOf(GameScene)).call(this));

        _this._running = false;

        //--reset common display obj array--//
        _Common2.default.displayObjs = [];

        /**
         * @type {number}
         */
        _this.maxCamEase = 1;

        /**
         * Flag to switch between tweenJs and TweenMax
         * @type {boolean}
         */
        _this.useTweenMax = true;

        var config = _config2.default;

        /**
         * @type {number}
         * @private
         */
        _this._numStars = config.numStars;

        /**
         * @type {number}
         * @private
         */
        _this._numObs = config.numObs;

        /**
         * @type {number}
         * @private
         */
        _this._numBalloons = config.numBalloons;

        /**
         * @type {number}
         * @private
         */
        _this._maxDx = config.maxDx;

        /**
         * @type {number}
         * @private
         */
        _this._boostPower = config.boostPower;

        /**
         * @type {number}
         * @private
         */
        _this._gravity = config.gravity;

        /**
         * @type {number}
         * @private
         */
        _this._bouncePushForward = config.bouncePushForward;

        /**
         * @type {number}
         * @private
         */
        _this._yBounceFactor = config.yBounceFactor;

        /**
         * Chance of on stars on obs
         * @type {number}
         */
        _this.starChance = config.starChance;

        /**
         * Chance of landing on dirt
         * @type {number}
         */
        _this.chanceNoneObs = config.chanceNoneObs;

        /**
         * Basic length of course
         * @type {number}
         */
        _this.basicLength = config.basicLength;

        /**
         * Additional random extra length
         * @type {number}
         */
        _this.randomLength = config.randomLength;

        /**
         * @type {number}
         */
        _this.randomObsDist = config.randomObsDist;

        /**
         * Minimum angle of cannon launch (max pointing upwards)
         * @type {number}
         */
        _this.minRotation = config.minCannonRot;

        /**
         * Tilt back angle when happo travels upwards
         * @type {number}
         */
        _this.happoBackRotation = config.happoBackRot;

        /**
         * @type {number}
         */
        _this.backTimeFactor = config.happoBackRotTimeFactor;

        /**
         * Tilt forward angle when happo travels down
         * @type {number}
         */
        _this.happoForwardRotation = config.happoForwRot;

        /**
         * @type {number}
         */
        _this.forwardTimeFactor = config.happoForwRotTimeFactor;

        /**
         * @type {number}
         * @private
         */
        _this._speedMin = config.happoMinSpeed;

        /**
         * @type {number}
         * @private
         */
        _this._speedMax = config.happoMaxSpeed;

        /**
         * @type {number}
         * @private
         */
        _this._bounceHeightFactor = config.bounceHeightFactor;

        /**
         * @type {number}
         * @private
         */
        _this._speed = _this._speedMin;

        /**
         * @type {JSON}
         */
        _this._starBurstConfig = _Common2.default.assets.getJSON("particles_pickup");

        /**
         * @type {number}
         */
        _this.tileSize = 1022;

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._mapHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._gameHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._uIntHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._back = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._bgHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._midBackHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._midHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._fgHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._particleHolder = new PIXI.Container();

        /**
         * @type {Array}
         * @private
         */
        _this._containers = [];

        /**
         * @type {*}
         * @private
         */
        _this._floorPosition = { x: 0, y: p3.View.height + 125 };

        /**
         * @type {PIXI.Spine}
         * @private
         */
        _this._happo = null;

        /**
         * @type {!PIXI.Point}
         * @private
         */
        _this._startPos = { x: 0, y: p3.View.height };

        /**
         *  Records total distance from start
         * @type {number}
         * @private
         */
        _this._totalDist = 0;

        /**
         * Text displaying distance travelled
         * @type {PIXI.Text}
         * @private
         */
        _this._distanceText = null;

        /**
         * Text displaying number of stars
         * @type {null}
         * @private
         */
        _this._starsText = null;

        /**
         *
         * @type {Array}
         * @private
         */
        _this._stars = [];

        /**
         * Used to check player has launched the happo
         * @type {boolean}
         * @private
         */
        _this._launched = false;

        /**
         * @type {number}
         * @private
         */
        _this._starsCollected = 0;

        /**
         * Push particle emitters onto this so they get updated
         * @type {Array}
         * @private
         */
        _this._particleEmitters = [];

        /**
         * textures for objects you bounce off
         * @type {object}
         */
        _this.objTextures = config.objTextures;

        /**
         * textures for objects you bounce off
         * @type {object}
         */
        _this.bounceFactors = config.bounceFactors;

        /**
         * @type {object}
         */
        _this.sounds = config.sounds;

        /**
         * @type {Array}
         * @private
         */
        _this._objects = [];

        /**
         * @type {Array}
         * @private
         */
        _this._oldObjects = [];

        /**
         * @type {PIXI.TilingSprite}
         * @private
         */
        _this._sky = null;

        /**
         * @type {null}
         * @private
         */
        _this._alien = null;

        /**
         * @type {String|PIXI.Sprite}
         * @private
         */
        _this._trackTarg = new PIXI.Sprite(PIXI.Texture.EMPTY);
        _this._gameHolder.addChild(_this._trackTarg); //created empty sprite and add to holder to get correct location relative to holder

        /**
         * @type {*[]}
         * @private
         */
        _this._blurFilter = [new PIXI.filters.BlurFilter(2, 1)];

        /**
         * @type {boolean}
         * @private
         */
        _this._shownAlienThisGame = false;

        /**
         * @type {boolean}
         * @private
         */
        _this._finishedIntro = false;

        /**
         * @type {Array}
         * @private
         */
        _this._clouds = [];

        /**
         * @type {number}
         * @private
         */
        _this._alienOffset = { x: -350 };

        /**
         * @type {null}
         * @private
         */
        _this._rotTween = null;

        /**
         * @type {Array}
         * @private
         */
        _this._happos = [];

        /**
         * @type {boolean}
         * @private
         */
        _this._justLaunched = true;
        return _this;
    }

    _createClass(GameScene, [{
        key: "init",
        value: function init() {
            var _this2 = this;

            //add to containers
            this._mapHolder.addChild(this._back, this._bgHolder, this._midBackHolder, this._midHolder, this._gameHolder, this._particleHolder, this._fgHolder);
            this.addChild(this._mapHolder, this._uIntHolder);
            this._containers = [this._back, this._bgHolder, this._midBackHolder, this._midHolder, this._gameHolder, this._particleHolder, this._fgHolder, this._mapHolder, this._uIntHolder];

            //init world
            this.initWorld();

            //init ui
            this.initUI();

            //--start audio playing--//
            _Common2.default.audio.playMusic("music_ready_loop_012");
            _Common2.default.audio.playSound("sfx_ambient_desert_loop_00", true);
            //howl.stop();
            // howl._sounds[0]._start = 0.05;
            // howl.play();
            //  console.log(howl);
            /*
             let music = Common.audio.playSound("music_ready_loop_012");
             music.on("end", ()=> {
             music.seek(0.051);
             music.play();
             });
             */
            this._mapHolder.scale.set(0.75);

            this.start();
            this.lastObjHei = this._floorPosition.y;

            var _debug = function _debug() {
                console.log(_this2._happo.x + ", " + _this2._happo.y);
                delay(_debug, 1, _this2);
            };
            // _debug();

            this.randomise();

            //--bring to front--//
            this._gameHolder.addChild(this._happo);
        }

        /**
         * Called after there are no more obstacles ahead, simply resuses the old ones by moving them all ahead of the player again
         */

    }, {
        key: "repopulate",
        value: function repopulate() {
            //--not sure need this weirdness but just want to make sure I leave one full and the other empty--//
            this._objects = [];
            this._objects = this._objects.concat(this._oldObjects);
            this._oldObjects = [];

            //give it a lil shuffle for more variety
            this._objects = _Common2.default.shuffleArr(this._objects);

            for (var i in this._objects) {
                var _obj = this._objects[i];
                _obj.x = this._happo.x + i * 8000 + (Math.random() * 6000 - 3000) + 5000;
                _obj.collided = false;
            }
        }

        /**
         * randomises the level
         */

    }, {
        key: "randomise",
        value: function randomise() {

            var totalStars = this._numStars;
            var totalObjs = this._numObs;
            var totalBalloons = this._numBalloons;

            for (var i = 0; i < totalStars; i++) {
                var star = createSprite("star", this._gameHolder);
                star.x = this._happo.x + i * 500 + (Math.random() * 75 - 75) + 1000;
                star.y = this._floorPosition.y - Math.random() * 5000 - 75;
                this._stars.push(star);
            }

            for (var _i = 0; _i < totalObjs; _i++) {
                var rand = Math.floor(Math.random() * Object.keys(this.objTextures).length);
                var _obj2 = createSprite(this.objTextures[rand], this._gameHolder);
                _obj2.type = this.objTextures[rand];
                if (_i > 0) _obj2.x = this._happo.x + _i * 8000 + (Math.random() * 6000 - 3000) + 5000;else _obj2.x = this._happo.x + 1100;
                _obj2.y = this._floorPosition.y + 50;
                _obj2.anchor.set(0.5, 1);
                _obj2.collided = false;
                this._objects.push(_obj2);
            }

            for (var _i2 = 0; _i2 < totalBalloons; _i2++) {
                var balloon = createSprite("balloons", this._gameHolder);
                balloon.type = "balloons";
                balloon.x = this._happo.x + _i2 * 8000 + (Math.random() * 6000 - 3000) + 5000;
                balloon.y = this._floorPosition.y - Math.random() * 1000 - 1000;
                balloon.anchor.set(0.5, 1);
                balloon.collided = false;
                this._objects.push(balloon);
            }

            //add a few objs at begining
            for (var _i3 = 1; _i3 <= 4; _i3++) {
                var _rand = Math.floor(Math.random() * Object.keys(this.objTextures).length);
                var _obj3 = createSprite(this.objTextures[_rand], this._gameHolder);
                _obj3.type = this.objTextures[_rand];
                _obj3.x = this._objects[0].x + _i3 * 1600;
                _obj3.y = this._floorPosition.y + 50;
                _obj3.anchor.set(0.5, 1);
                _obj3.collided = false;
                this._objects.push(_obj3);
            }
        }
    }, {
        key: "updateHappo",
        value: function updateHappo() {
            var _this3 = this;

            //--prevent happo going too fast--//
            if (this._happo.dx > this._maxDx) this._happo.dx = this._maxDx;

            //--bounce happo off the floor--//
            if (this._happo.y > this._floorPosition.y - 50 && this._happo.dy > 0) {

                this._happo.dy = -this._happo.dy;
                this.justBounced = true;

                delay(function () {
                    _this3.justBounced = false;
                }, 0.15, this);

                if (!this.changedAnim && !this._happo.finalAnim) {
                    this._happo.state.setAnimation(0, "flight" + Math.ceil(Math.random() * 9), true);
                    this.changedAnim = true;
                    delay(function () {
                        _this3.changedAnim = false;
                    }, 3, this);
                }

                //--bring happo back above the floor--//
                this._happo.y = this._floorPosition.y - 50.1;

                if (!this.noneSoundPlaying) {
                    _Common2.default.audio.playSound(this.sounds["none"], {
                        onEnd: function onEnd() {
                            _this3.noneSoundPlaying = false;
                        }
                    });
                    this.noneSoundPlaying = true;
                }

                //this._dustEmitter.emit = false;
                //this._dustEmitter.cleanup();

                this._dustEmitter.emit = true;

                //--randomise rotation speed--//
                if (this._happo.dx >= 5) {
                    this._happo.rotSpeed = (Math.random() - 0.5) * 0.2;
                }
            }

            //--if happo's velocity is zero then end the game--//
            if (this._happo.dx <= 0) {
                //console.log(this._happo.dy);
                //console.log(Math.round(this._happo.dy));
                if (Math.floor(this._happo.dy) <= 1 && Math.ceil(this._happo.dy) >= -1 && this._happo.y > 840) {
                    this._running = false;
                    this._camera.update = function () {};
                    this._gameComplete = true;
                    this.gameOver();
                    return;
                }
            } else if (this._happo.dx < 60 && !this._happo.killRotate) {

                if (TweenMax.isTweening(this._happo)) {
                    //console.log("had to kill tween on happo");
                    TweenMax.killTweensOf(this._happo);
                }

                //console.log("killing rot");
                //console.log(this._happo.rotation);

                this._happo.killRotate = true;

                var targetRot = Math.round(this._happo.rotation / (Math.PI * 2)) * (Math.PI * 2);
                TweenMax.to(this._happo, 1, {
                    rotation: targetRot, ease: Power0.easeNone, onComplete: function onComplete() {
                        //console.log("finished rotating happo to " + targetRot);
                    }
                });
            } else if (this._happo.dx < 10) {
                this._happo.state.setAnimation(0, "hitground" + Math.ceil(Math.random() * 2) + "stop");
                this._happo.finalAnim = true;
            }

            if (this._happo.dy > 60) {
                this._happo.killRotate = false;
                this._happo.finalAnim = false;
            }

            if (this._happo.dy < 1 && this._happo.dy > -1 && this._happo.y > 840) {
                //console.log("forced dy to zero");
                this._happo.dy = 0;
            }

            //--remove some velocity to act as friction, this is removed over a short period of time then the flag
            //--is set to false and friction stops getting applied--//
            if (this.justBounced) {
                this._happo.dx -= 0.5;
                this._happo.dy += 2.5;
            }

            //--lock min x vel to be zero (dont go negative)--//
            if (this._happo.dx < 0) this._happo.dx = 0;

            //--update happo veloctiy and position--//
            this._happo.dy -= this._gravity;
            this._happo.x += this._happo.dx;
            this._happo.y += this._happo.dy;
            if (!this._happo.killRotate) this._happo.rotation += this._happo.rotSpeed;

            this.extraContainer.position.set(this._happo.x, this._happo.y);

            //--check for collision and set dx , dy for use next frame--//
            for (var i in this._objects) {

                if (this._objects[i].collided) continue;
                if (_Common2.default.collisionOBB(this._happo, this._objects[i], 0.9)) {

                    var type = this._objects[i].type;
                    var bounceFactor = this.bounceFactors[type];
                    this._happo.dx += this._bouncePushForward;
                    this._happo.dy = -bounceFactor * this._yBounceFactor;
                    this._objects[i].collided = true;

                    //--randomise rotation speed--//
                    this._happo.rotSpeed = (Math.random() - 0.5) * 0.2;

                    if (!this.changedAnim && !this._happo.finalAnim) {
                        this._happo.state.setAnimation(0, "flight" + Math.ceil(Math.random() * 9), true);
                        this.changedAnim = true;

                        delay(function () {
                            _this3.changedAnim = false;
                        }, 3, this);
                    }

                    //--play the sound--//
                    _Common2.default.audio.playSound(this.sounds[type]);

                    TweenMax.to(this._objects[i].scale, 0.1, {
                        y: 0.7,
                        x: 1.25,
                        ease: Bounce.easeOut,
                        yoyo: true,
                        repeat: 1
                    });

                    //console.log("collide with obj " + type);

                    break;
                }
            }
        }
    }, {
        key: "update",
        value: function update() {
            var _this4 = this;

            for (var i in this._clouds) {
                this._clouds[i].x -= 0.05; //cloud drift
            }

            //--update particles--//
            for (var _i4 = 0; _i4 < this._particleEmitters.length; _i4++) {
                if (!this._particleEmitters[_i4]) continue;
                this._particleEmitters[_i4].update(deltaTime);
            }

            //     this.extraContainer.rotation = this._happo.rotation;

            this.pauseBtn.enabled = this._finishedIntro;
            this.pauseBtn.animate = this._finishedIntro;
            this.pauseBtn.visible = this._finishedIntro;

            this._dustEmitter.updateOwnerPos(this._happo.x, this._happo.y - 45);
            //  this._boostReadyEmitterHappo.updateOwnerPos(this._happo.x, this._happo.y - 45);

            if (!this._running || _Common2.default.paused || this._gameComplete) {
                return;
            }

            //--Tween.js update--//
            if (!this.useTweenMax) TWEEN.update();

            if (this._boostReadyEmitter.emit) {
                this._boostReadyEmitter.updateSpawnPos(this._happo.x + 25, this._happo.y);
                //this._boostReadyEmitter.rotate(Common.rad2deg(this._happo.rotation));
            }

            //--update parralax camera--//
            this._camera.update();

            var happoGlobal = this._happo.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));

            // ---- Collision detect stars ----
            for (var _i5 = 0; _i5 < this._stars.length; _i5++) {
                if (this._stars[_i5].collected || this._starsCollected >= 60) continue;
                if (_Common2.default.collisionOBB(this._happo, this._stars[_i5])) {

                    this._starsCollected++;

                    //==handle circular fill for star button==//

                    var rad = 52;
                    this._starBtnBack.removeChild(this._graphics);
                    this._graphics.clear();
                    this._graphics.destroy();
                    this._graphics = new PIXI.Graphics();
                    this._graphics.pivot.set(0.5);
                    this._graphics.x = -rad * 0.5 - 4.5;
                    // this._graphics.y = rad * 0.5 - 1;
                    this._graphics.y = this._graphicsY;
                    this._graphics.lineStyle(21, 0xffe011);

                    this._currentFill = -Math.PI * 0.5 + 2 * Math.PI / 20 * this._starsCollected;

                    if (this._starsCollected === 20) {
                        this._currentFill += 0.05;
                    }

                    this._graphics.arc(32, 57, rad, -Math.PI * 0.5, this._currentFill);
                    this._starBtnBack.addChild(this._graphics, this._starBtnFront);

                    //==end circle fill==//

                    _Common2.default.audio.playSound("sfx_star_pickup_00");
                    //  this._starsText.text = "" + this._starsCollected;
                    //     if (this._starsCollected <= 20) this._fillMask.x += (150 / 20);
                    var emitter = new PIXI.particles.Emitter(this._gameHolder, [_Common2.default.assets.getTexture("part_star")], this._starBurstConfig);
                    emitter.updateOwnerPos(this._stars[_i5].x, this._stars[_i5].y);
                    emitter.playOnceAndDestroy();
                    this._particleEmitters.push(emitter);
                    this._stars[_i5].collected = true;
                    // this._stars[i].visible = false;
                    //this._stars.splice(0, 1);
                    if (this._starsCollected === 20 && _Common2.default.isFirstPlay) {
                        var str = void 0;
                        if (p3.Device.isMobile) str = "finger";else str = "cursor";
                        this.starFinger.state.setAnimation(0, str + "_tap", true);
                        //this._happo.autoUpdate = false;
                        this._happo.state.timeScale = 0;
                        //TweenMax.pauseAll();
                        TweenMax.killTweensOf(this._happo);

                        this._running = false;
                        _Common2.default.isFirstPlay = false;
                        this.starFinger.visible = true;
                        this.starFinger.x = this._starBtnBack.x - this._starBtnBack.width * 0.5;
                        this.starFinger.y = this._starBtnBack.y;

                        this._uIntHolder.addChild(this.starFinger);
                    }
                    if (this._starsCollected >= 20 && !this._starParticles.emit) {
                        _Common2.default.audio.playSound("sfx_star_jump_ready_00");
                        //    this._happo.filters = this.glowFilter;
                        this._starParticles.emit = true;
                        //   this._boostReadyEmitter.emit = true;
                        //this._boostReadyEmitterHappo.emit = true;
                        this._starBtnFront.texture = _Common2.default.assets.getTexture("btn_boost_on");

                        this._starBtnBack.filters = this.glowFilter;

                        this._starTween = TweenMax.to(this._starBtnFront.scale, 0.5, {
                            x: 1.25,
                            y: 1.25,
                            yoyo: true,
                            repeat: -1,
                            ease: Power0.easeNone
                        });
                    }

                    this._stars[_i5].oldPos = new PIXI.Point(this._stars[_i5].x, this._stars[_i5].y);

                    var localPos = this._stars[_i5].getGlobalPosition();
                    localPos.x -= p3.View.width * 0.5;
                    this._uIntHolder.addChild(this._stars[_i5]);
                    this._stars[_i5].position.set(localPos.x, localPos.y);
                    this._stars[_i5].scale.set(0.85);
                    TweenMax.to(this._stars[_i5].scale, 0.5, { x: 0, y: 0, ease: Power0.easeNone });
                    TweenMax.to(this._stars[_i5], 0.5, { x: this._starBtnBack.x, ease: Power0.easeNone });
                    TweenMax.to(this._stars[_i5], 0.5, {
                        y: this._starBtnBack.y,
                        ease: Power1.easeOut,
                        onComplete: function onComplete() {
                            _this4._starBtnBack.scale.set(1);
                            TweenMax.from(_this4._starBtnBack.scale, 0.5, { x: 0.9, y: 0.9, ease: Bounce.bounceOut });
                            _this4._starBtnEmitter.emit = true;
                        }
                    });

                    break;
                }
            }

            // ---- Track distance ----
            if (this._launched) {
                this._totalDist = Math.round(_Common2.default.distance(this._startPos.x, 0, this._happo.x, 0) * 0.007);
                this._distanceText.text = "" + this._totalDist;
                if (this._happo.y < -550) {
                    if (this._mapHolder.scale !== 0.5 && !TweenMax.isTweening(this._mapHolder)) {
                        TweenMax.to(this._mapHolder.scale, 0.5, { x: 0.5, y: 0.5, ease: Power0.easeNone });
                    }
                } else {
                    if (this._mapHolder.scale !== 0.75 && !TweenMax.isTweening(this._mapHolder)) {
                        TweenMax.to(this._mapHolder.scale, 0.25, { x: 0.75, y: 0.75, ease: Power0.easeNone });
                    }
                }
            } else if (this._inputData) {
                var pos = this._inputData.getLocalPosition(this);
                if (!isNaN(pos.x)) {
                    var minRot = this.minRotation,
                        maxRot = -0.2;
                    var rot = _Common2.default.angle(this._startPos.x - 500, this._startPos.y, pos.x, pos.y);
                    if (Math.round(rot) !== Math.round(this._cannon.rotation)) _Common2.default.audio.playSound("sfx_cannon_move_0" + Math.round(Math.random() * 2));
                    if (rot > minRot && rot < maxRot) {
                        this._cannon.rotation = rot;
                        this._cannonEmitter2.rotate(_Common2.default.rad2deg(rot));
                    }
                }
            }

            //--update happo dx and dy--//
            if (this._launched) {
                this.updateHappo();
            }

            //--update camera track target--//
            this._trackTarg.x = this._happo.x;
            this._trackTarg.y = this._happo.y; // + 225;

            //--move alien with player--//
            this._alien.x = this._happo.x + this._alienOffset.x;

            //--update tile positions--//
            if (this.floorTiles.x < this._happo.x - this.floorTiles.width * 0.5) {
                this.floorTiles.x = this.floorTiles.x + this.floorTiles.width * 0.25;
            }

            if (this._happo.dx > 0) {

                var tilesGlobal = this.midTiles.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                if (tilesGlobal.x < happoGlobal.x - this.tileSize * 3) {
                    this.midTiles.x = this.midTiles.x + this.tileSize * 2;
                    // console.log("moved mid tiles");
                }
                tilesGlobal = this.midBkTiles.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                if (tilesGlobal.x < happoGlobal.x - this.tileSize * 3) {
                    this.midBkTiles.x = this.midBkTiles.x + this.tileSize * 2;
                    //  console.log("moved mid back tiles");
                }

                var mounts = this.mountainTiles;
                for (var _i6 in mounts) {
                    var sp = mounts[_i6];
                    var spGlob = sp.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                    if (spGlob.x < happoGlobal.x - sp.width * 0.5) {
                        sp.x = mounts[mounts.length - 1].x + sp.width;
                        mounts.splice(_i6, 1);
                        mounts.push(sp);
                        //  console.log("moved mountains");
                        break;
                    }
                }
            }

            for (var _i7 in this._objects) {
                if (this._objects[_i7].x < this._happo.x - p3.View.width) {
                    //resuse obj
                    //this._objects[i].x += p3.View.width * 10;
                    this._oldObjects.push(this._objects[_i7]);
                    this._objects.splice(_i7, 1);
                    if (this._objects.length === 0) {
                        this.repopulate();
                    }
                }
            }

            for (var _i8 in this._stars) {
                if (TweenMax.isTweening(this._stars[_i8])) continue;

                if (this._stars[_i8].x < this._happo.x - p3.View.width) {
                    //resuse obj
                    var star = this._stars[_i8];
                    star.x = this._happo.x + _i8 * 500 + (Math.random() * 75 - 75) + 1000;
                    star.y = this._floorPosition.y - Math.random() * 5000 - 75;
                    //  this._stars[i].x += p3.View.width * 2;
                    //  this._stars[i].y += Math.random() * 75 - 32.5;
                    if (this._stars[_i8].y > this._floorPosition.y - 75) {
                        this._stars[_i8].y -= Math.random() * 100;
                    }
                    this._stars[_i8].collected = false;
                    this._stars[_i8].visible = true;
                    this._stars[_i8].scale.set(1);
                    this._gameHolder.addChild(this._stars[_i8]);
                }
            }

            //repos deco elements to reuse the sprites
            var obj = void 0,
                globalPos = void 0;
            for (var _i9 in this._decos) {
                obj = this._decos[_i9];
                globalPos = obj.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                if (!(globalPos.x - happoGlobal.x < -p3.View.width - obj.width)) {
                    obj.x = this._happo.x + Math.random() * p3.View.width * 2 + p3.View.width * 2;
                }
            }

            //repos deco elements to reuse the sprites
            for (var _i10 in this._decosMG) {
                obj = this._decosMG[_i10];
                globalPos = obj.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                if (globalPos.x - happoGlobal.x < -p3.View.width - obj.width) {
                    obj.x = obj.x + Math.random() * p3.View.width * 10 + p3.View.width * 5;
                }
            }

            //repos deco elements to reuse the sprites
            for (var _i11 in this._decosFG) {
                obj = this._decosFG[_i11];
                globalPos = obj.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                if (globalPos.x - happoGlobal.x < -p3.View.width - obj.width) {
                    obj.x = obj.x + Math.random() * p3.View.width * 5 + p3.View.width * 5;
                }
            }

            //repos deco elements to reuse the sprites
            for (var _i12 in this._decosBG) {
                obj = this._decosBG[_i12];
                globalPos = obj.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                if (globalPos.x - happoGlobal.x < -p3.View.width - obj.width) {
                    obj.x = obj.x + Math.random() * p3.View.width * 5 + p3.View.width * 5;
                }
            }

            return;

            //--depth sort some stuff?--??
            this._bgHolder.children.sort(function (e, t) {
                return e.position.y > t.position.y ? 1 : e.position.y < t.position.y ? -1 : e.position.x > t.position.x ? 1 : e.position.x < t.position.x ? -1 : 0;
            });
            this._midHolder.children.sort(function (e, t) {
                return e.position.y > t.position.y ? 1 : e.position.y < t.position.y ? -1 : e.position.x > t.position.x ? 1 : e.position.x < t.position.x ? -1 : 0;
            });

            if (this.skidding) {
                this._dustEmitter.updateSpawnPos(this._happo.x, this._happo.y - 15);
                this._dustEmitter.emit = true;
            }

            //view culling
            for (var _i13 in _Common2.default.displayObjs) {
                var sprite = _Common2.default.displayObjs[_i13];
                if (sprite.dead || !sprite || !sprite.transform) continue;
                // console.log(sprite);
                var globalCoordinates = sprite.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                //const happoGlobal = this._happo.toGlobal(new PIXI.Point(p3.View.width * 0.5, 0));
                sprite.renderable = !(globalCoordinates.x - happoGlobal.x < -p3.View.width - sprite.width * 5);
                //bit cheeky, basically if our sprite has gone off left edge of screen, set visible false so its transform isnt updated
                if (!sprite.renderable) {
                    sprite.visible = false;
                    this._gameHolder.addChild(sprite); //move to container
                    this._gameHolder.removeChild(sprite); //remove from
                    sprite.dead = true;
                    //remove from arr
                    // Common.displayObjs.splice(i, 1);
                }
                sprite.renderable = !(globalCoordinates.x - happoGlobal.x > p3.View.width + sprite.width * 5);
            }
        }
    }, {
        key: "jumpHappo",
        value: function jumpHappo() {
            var _this5 = this;

            var delayTime = 4;
            var jump = function jump() {
                var rand = Math.floor(Math.random() * _this5._happos.length);
                var happo = _this5._happos[rand];
                happo.tween.pause();
                TweenMax.to(happo, 0.25, { y: happo.y - 25, yoyo: true, repeat: 1 });
                TweenMax.to(happo.scale, 0.25, {
                    x: happo.scale.x - 0.05,
                    y: happo.scale.y + 0.05,
                    yoyo: true,
                    repeat: 1,
                    onComplete: function onComplete() {
                        happo.tween.resume();
                    }
                });
            };
            delay(jump, delayTime, this);
        }
    }, {
        key: "start",
        value: function start() {
            var _this6 = this;

            this.jumpHappo();

            var tempHappo = new PIXI.spine.Spine(_Common2.default.assets.getSpineData("stunt_happo_standing"));
            ///delay(()=> {
            ///     this._running = false
            //  }, 0.15, this);
            tempHappo.skeleton.setToSetupPose();
            tempHappo.autoUpdate = true;
            tempHappo.state.setAnimation(0, "run", true);
            tempHappo.scale.set(0.35);
            tempHappo.position.set(this._startPos.x, this._startPos.y /* - 75*/);
            tempHappo.y = p3.View.height * 1.5 - 225;
            tempHappo.x = -725;
            disp.push(tempHappo);
            this.starterHappo = tempHappo;
            this._gameHolder.addChild(tempHappo, this._cannon, this._canFront); //reorder
            TweenMax.to(tempHappo, 1, {
                x: this._cannon.x - 210,
                ease: Power0.easeNone,
                onComplete: function onComplete() {
                    tempHappo.state.setAnimation(0, "wave");
                    _Common2.default.audio.playSound("sfx_happo_ok_00");
                    delay(function () {
                        tempHappo.state.setAnimation(0, "run");
                        TweenMax.to(tempHappo, 0.5, {
                            x: tempHappo.x + 150,
                            ease: Power0.easeNone,
                            onComplete: function onComplete() {
                                //tempHappo.visible = false;
                                tempHappo.state.setAnimation(0, "idle");
                                tempHappo.x = 55;
                                tempHappo.y = 12;
                                tempHappo.scale.set(0.2);
                                _this6._cannon.addChild(tempHappo, _this6._cannonMainFront);
                                tempHappo.rotation = _Common2.default.deg2rad(75);
                                TweenMax.from(tempHappo, 0.5, { x: tempHappo.x - 45 });
                                TweenMax.from(tempHappo.scale, 0.5, {
                                    x: tempHappo.scale.x - 0.2,
                                    y: tempHappo.scale.y - 0.2,
                                    ease: Power1.easeOut
                                });
                            }
                        });

                        //Common.isFirstPlay = true;

                        //--client wants tutorial every time, hence why if true is true comparison--//
                        if (true) {

                            var finger = new PIXI.spine.Spine(_Common2.default.assets.getSpineData("tutorial"));
                            finger.skeleton.setToSetupPose();
                            finger.autoUpdate = true;
                            var str = void 0;
                            if (p3.Device.isMobile) str = "finger";else str = "cursor";
                            finger.state.setAnimation(0, str + "_aim", true);
                            finger.scale.set(0.5);
                            finger.position.set(_this6._startPos.x + 350, _this6._startPos.y - 200);
                            _this6._particleHolder.addChild(finger);
                            finger.visible = false;
                            _this6.starFinger = finger;
                            //this.tutorialMovement = true;

                            delay(function () {
                                if (!_this6._launched) {
                                    //finger.visible = true;
                                    _this6._cannon.tutLine.visible = true;
                                    _this6._tutArrow.visible = true;
                                    _this6._cannon.rotation = _Common2.default.deg2rad(-45);
                                    _this6.tutTween = TweenMax.to(_this6._cannon, 0.9, {
                                        rotation: _Common2.default.deg2rad(-15),
                                        ease: Power0.easeNone,
                                        yoyo: true,
                                        repeat: 2,
                                        delay: 0.5,
                                        repeatDelay: 1,
                                        onComplete: function onComplete() {
                                            _this6._running = true;
                                            _this6._finishedIntro = true;
                                            //  this.tutorialMovement = false;
                                        },
                                        onRepeat: function onRepeat() {
                                            _this6._tutArrow.scale.y *= -1;
                                        }
                                    });
                                }
                            }, 1.5, _this6);
                            delay(function () {
                                _this6._cannon.tutLine.visible = false;
                                _this6._tutArrow.visible = false;
                            }, 8, _this6);
                        } else {
                            _this6._running = true;
                            _this6._finishedIntro = true;
                        }
                    }, 1, _this6);
                }
            });
        }
    }, {
        key: "end",
        value: function end() {
            this._running = false;
            this.signals.next.dispatch(this);
        }

        /**
         * @deprecated
         */

    }, {
        key: "tweenAlien",
        value: function tweenAlien() {
            var _this7 = this;

            return;
            if (this._shownAlienThisGame) {
                this._alien.visible = false;
                return;
            }

            this._alien.visible = true;
            TweenMax.from(this._alien, 1.5, {
                x: -p3.View.width * 0.5,
                y: -p3.View.height * 0.5,
                ease: Power0.easeNone,
                onComplete: function onComplete() {
                    TweenMax.to(_this7._alien, 1, {
                        y: _this7._alien.y + 250,
                        yoyo: true,
                        repeat: 3,
                        ease: Power0.easeNone,
                        onComplete: function onComplete() {
                            TweenMax.to(_this7._alien, 1.5, {
                                x: -p3.View.width * 0.5,
                                y: -p3.View.height * 0.5,
                                ease: Power0.easeNone,
                                onComplete: function onComplete() {
                                    _this7._alien.position.set(_this7.alienStart.x, _this7.alienStart.y);
                                    _this7._alien.visible = false;
                                    _this7._shownAlienThisGame = true;
                                }
                            });
                        }
                    });
                }
            });
        }

        /**
         * @deprecated
         */

    }, {
        key: "runCourse",
        value: function runCourse() {
            var _this8 = this;

            var logCourse = false;
            var useTweenMax = this.useTweenMax;
            var force3d = true;

            var bounceNext = function bounceNext() {

                if (_this8._objects.length > 1) {

                    var objIndex = _this8._objects.length - 1;
                    var nextObj = _this8._objects[objIndex];

                    var dist = nextObj.x - _this8._happo.x;
                    var time = dist / _this8._speed;

                    //this._speed -= 10;

                    var yHei = _this8.lastObjHei - dist * _this8._bounceHeightFactor - 75;
                    if (_this8.lastBounceWasBalloon) {
                        _this8.lastBounceWasBalloon = false;
                        if (logCourse) console.warn("balloon bounce");
                        yHei *= 1.5;
                        time *= 1.5;
                        if (nextObj.type !== "balloons") {
                            if (logCourse) console.log("last balloon in series");
                            time *= 1.25;
                        }
                    } else {
                        if (nextObj.type === "balloons") {
                            if (logCourse) console.warn("super bounce to reach balloons");
                            yHei -= 1250;
                        }
                    }

                    if (_this8.lowLaunch) {
                        _this8.lowLaunch = undefined;
                        yHei += 350;
                        for (var i = 0; i < _this8._objects.length; i++) {
                            _this8._objects[i].x += 800;
                        }
                        for (var _i14 = 0; _i14 < _this8._stars.length; _i14++) {
                            _this8._stars[_i14].x += 800;
                        }
                    } else if (_this8._justLaunched) {
                        _this8._justLaunched = false;
                        yHei += 150;
                    }

                    if (_this8.highLaunch) {
                        _this8.highLaunch = undefined;
                        _this8._happo.x -= 85;
                        _this8._happo.y -= 15;
                    }

                    if (yHei > _this8._happo.y) {
                        console.warn("target height is lower than the happo....");
                        yHei = _this8._happo.y - 650;
                    }

                    if (_this8._rotTween) _this8._rotTween.kill();
                    _this8._rotTween = TweenMax.to(_this8._happo, time * _this8.backTimeFactor, {
                        rotation: _Common2.default.deg2rad(_this8.happoBackRotation),
                        ease: Power0.easeNone,
                        onComplete: function onComplete() {
                            _this8._rotTween = TweenMax.to(_this8._happo, time * _this8.forwardTimeFactor, {
                                rotation: _Common2.default.deg2rad(_this8.happoForwardRotation),
                                ease: Power0.easeNone
                            });
                        }
                    });

                    if (!useTweenMax) {
                        _this8._horTween = new TWEEN.Tween(_this8._happo) // Create a new tween that modifies 'coords'.
                        .to({ x: nextObj.x }, time * 1000) // Move to (300, 200) in 1 second.
                        .easing(TWEEN.Easing.Linear.None) // Use an easing function to make the animation smooth.
                        .start(); // Start the tween immediately.
                        _this8._upTween = new TWEEN.Tween(_this8._happo) // Create a new tween that modifies 'coords'.
                        .to({ y: yHei }, time / 2 * 1000) // Move to (300, 200) in 1 second.
                        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
                        .start(); // Start the tween immediately.

                        _this8._downTween = new TWEEN.Tween(_this8._happo) // Create a new tween that modifies 'coords'.
                        .to({ y: nextObj.y - nextObj.height }, time / 2 * 1000) // Move to (300, 200) in 1 second.
                        .easing(TWEEN.Easing.Quadratic.In); // Use an easing function to make the animation smooth.

                        _this8._upTween.onComplete(function () {
                            _this8._downTween.start();
                            if (_this8.relaunched) {
                                _this8.relaunched = false;
                                _this8._happo.scale.set(0.35);
                                var myString = "flight" + Math.ceil(Math.random() * 9);
                                _this8._happo.state.setAnimation(0, myString, true);
                            }
                        });

                        _this8._downTween.onComplete(function () {
                            if (nextObj.type !== "pit") {
                                TweenMax.to(obj.scale, 0.1, {
                                    y: 0.7,
                                    x: 1.25,
                                    ease: Bounce.easeOut,
                                    yoyo: true,
                                    repeat: 1
                                });
                            }

                            if (nextObj.type !== "pit") {
                                _Common2.default.audio.playSound(_this8.sounds[_this8._objects[0].type]);
                                if (nextObj.type === "none") {
                                    _this8._dustEmitter.emit = false;
                                    _this8._dustEmitter.cleanup();
                                    _this8._dustEmitter.updateSpawnPos(_this8._happo.x, _this8._happo.y - 45);
                                    delay(function () {
                                        _this8._dustEmitter.emit = true;
                                    }, 0.1, _this8);
                                }
                            } else {
                                if (nextObj.particle === "water") {
                                    _this8._waterEmitter.updateSpawnPos(_this8._happo.x, _this8._happo.y);
                                    _this8._waterEmitter.emit = true;
                                    _Common2.default.audio.playSound("sfx_bounce_puddle_00");
                                } else {
                                    _this8._mudEmitter.updateSpawnPos(_this8._happo.x, _this8._happo.y);
                                    _this8._mudEmitter.emit = true;
                                    _Common2.default.audio.playSound("sfx_bounce_mud_00");
                                }
                            }
                            if (nextObj.type === "balloons") {
                                _this8.lastBounceWasBalloon = true;
                            }
                            _this8.lastObjHei = nextObj.y;

                            _this8._oldObjects.push(_this8._objects[objIndex]);

                            _this8._objects.pop();
                            _this8._speed *= 0.85;
                            if (_this8._speed < _this8._speedMin) _this8._speed = _this8._speedMin;
                            var myString = "flight" + Math.ceil(Math.random() * 9);
                            _this8._happo.state.setAnimation(0, myString, true);
                            _this8._happo.scale.set(0.35);
                            bounceNext();
                        });
                    } else {
                        _this8._horTween = TweenMax.to(_this8._happo, time, {
                            x: nextObj.x,
                            ease: Power0.easeNone,
                            autoKill: true,
                            force3D: force3d
                        });
                        _this8._upTween = TweenMax.to(_this8._happo, time * 0.5, {
                            y: yHei,
                            ease: Power1.easeOut,
                            onComplete: function onComplete() {
                                if (_this8.relaunched) {
                                    _this8.relaunched = false;
                                    _this8._happo.scale.set(0.35);
                                    var myString = "flight" + Math.ceil(Math.random() * 9);
                                    _this8._happo.state.setAnimation(0, myString, true);
                                }
                            },
                            force3D: force3d
                        });
                        _this8._downTween = TweenMax.to(_this8._happo, time * 0.5, {
                            y: _this8._objects[objIndex].y - _this8._objects[objIndex].height,
                            ease: Power1.easeIn,
                            delay: time * 0.5,
                            force3D: force3d,
                            onComplete: function onComplete() {
                                var obj = _this8._objects[objIndex];
                                if (obj.type !== "pit") {
                                    TweenMax.to(obj.scale, 0.1, {
                                        y: 0.7,
                                        x: 1.25,
                                        ease: Bounce.easeOut,
                                        yoyo: true,
                                        repeat: 1
                                    });
                                }

                                if (_this8._objects[objIndex].type !== "pit") {
                                    _Common2.default.audio.playSound(_this8.sounds[_this8._objects[objIndex].type]);
                                    if (_this8._objects[objIndex].type === "none") {
                                        _this8._dustEmitter.emit = false;
                                        _this8._dustEmitter.updateSpawnPos(_this8._happo.x, _this8._happo.y - 45);
                                        delay(function () {
                                            _this8._dustEmitter.emit = true;
                                        }, 0.1, _this8);
                                    }
                                } else {
                                    if (_this8._objects[objIndex].particle === "water") {
                                        _this8._waterEmitter.updateSpawnPos(_this8._happo.x, _this8._happo.y);
                                        _this8._waterEmitter.emit = true;
                                        _Common2.default.audio.playSound("sfx_bounce_puddle_00");
                                    } else {
                                        _this8._mudEmitter.updateSpawnPos(_this8._happo.x, _this8._happo.y);
                                        _this8._mudEmitter.emit = true;
                                        _Common2.default.audio.playSound("sfx_bounce_mud_00");
                                    }
                                }
                                if (_this8._objects[objIndex].type === "balloons") {
                                    _this8.lastBounceWasBalloon = true;
                                }
                                _this8.lastObjHei = _this8._objects[objIndex].y;

                                _this8._oldObjects.push(_this8._objects[objIndex]);

                                _this8._objects.pop();
                                _this8._speed *= 0.85;
                                if (_this8._speed < _this8._speedMin) _this8._speed = _this8._speedMin;
                                var myString = "flight" + Math.ceil(Math.random() * 9);
                                _this8._happo.state.setAnimation(0, myString, true);
                                _this8._happo.scale.set(0.35);
                                bounceNext();
                            }
                        });
                    }
                } else {
                    _this8._happo.rotation = 0;
                    _this8.skid();
                }
            };
            bounceNext();
        }

        /**
         * @deprecated
         * Do skid ending animation and game ending
         */

    }, {
        key: "skid",
        value: function skid() {
            var _this9 = this;

            TweenMax.killTweensOf(this._happo);

            this.skidding = true;
            this._happo.rotation = 0;

            var count = 0;
            var maxBounces = 4;
            var dist = 1200;

            var tweener = function tweener() {

                var time = dist / _this9._speed;

                if (count === maxBounces * 0.5) {
                    if (Math.random() < 0.5) {
                        _this9.skidding = false;
                        //do puddle ending
                        var puddleDist = 1600;
                        var yHei = puddleDist * _this9._bounceHeightFactor;

                        var str = "",
                            isMud = false;
                        if (Math.random() < 0.5) {
                            str = "pond_" + Math.ceil(Math.random() * 2);
                        } else {
                            str = "puddle_" + Math.ceil(Math.random() * 2);
                            isMud = true;
                        }

                        var puddle = createSprite(str, _this9._gameHolder);
                        puddle.position.set(_this9._happo.x + puddleDist, _this9._floorPosition.y - 65);
                        var time2 = puddleDist / _this9._speed;

                        _this9._gameHolder.addChild(_this9._happo);

                        //hor
                        TweenMax.to(_this9._happo, time2, { x: puddle.x, ease: Power0.easeNone });
                        //up
                        TweenMax.to(_this9._happo, time2 * 0.5, { y: yHei, ease: Power1.easeOut });
                        //down
                        TweenMax.to(_this9._happo, time2 * 0.5, {
                            y: puddle.y + 35,
                            ease: Power1.easeIn,
                            delay: time2 * 0.5,
                            onComplete: function onComplete() {
                                if (!isMud) {
                                    _this9._waterEmitter.updateSpawnPos(_this9._happo.x, _this9._happo.y);
                                    _this9._waterEmitter.emit = true;
                                    _Common2.default.audio.playSound("sfx_bounce_puddle_00");
                                } else {
                                    _this9._mudEmitter.updateSpawnPos(_this9._happo.x, _this9._happo.y);
                                    _this9._mudEmitter.emit = true;
                                    _Common2.default.audio.playSound("sfx_bounce_mud_00");
                                }

                                _this9._gameComplete = true;
                                _this9._happo.visible = false;
                                //cheeky overide
                                _this9._camera.update = function () {};
                                _this9.gameOver();
                            }
                        });
                        return;
                    }
                }

                if (count < maxBounces) {
                    //--horizontal tween--//
                    TweenMax.to(_this9._happo, time, { x: _this9._happo.x + dist, ease: Power0.easeNone });

                    //--vertical tween--//
                    TweenMax.to(_this9._happo, time * 0.5, { y: _this9._happo.y - dist * 0.25, ease: Power1.easeOut });
                    TweenMax.to(_this9._happo, time * 0.5, {
                        y: _this9._floorPosition.y,
                        ease: Power1.easeIn,
                        delay: time * 0.5,
                        onComplete: function onComplete() {
                            count++;
                            dist *= 0.75;
                            tweener();
                        }
                    });
                } else {
                    //--horizontal tween--//
                    TweenMax.to(_this9._happo, time * 10, {
                        x: _this9._happo.x + dist * 10,
                        ease: Power0.easeNone,
                        onComplete: function onComplete() {
                            _this9._gameComplete = true;
                            _this9._happo.state.setAnimation(0, "hitground" + Math.ceil(Math.random() * 2) + "stop");
                            _this9.skidding = false;
                            //cheeky overide
                            _this9._camera.update = function () {};
                            _this9.gameOver();
                        }
                    });
                }
            };
            tweener();
        }
    }, {
        key: "initWorld",
        value: function initWorld() {
            this.initObjects();
            this.initCamera();
            this.initParticles();
        }
    }, {
        key: "initCamera",
        value: function initCamera() {
            this._camera = new p3.Camera(new PIXI.Point(0, p3.View.height * 0.5), false);
            this._camera.trackEase = this.maxCamEase;
            this._camera.y = this._camera.view.y;
            this._camera.bounds.height = (p3.View.height - this._camera.view.y + 200) * 0.75 - 75;
            _Common2.default.camera = this._camera;

            this._camera.addLayer("bg", this._bgHolder, new PIXI.Point(0.05, 1));
            this._camera.addLayer("fg", this._fgHolder, new PIXI.Point(0.9, 1));

            this._camera.addLayer("game", this._gameHolder, new PIXI.Point(0.7, 1));
            this._camera.addLayer("gamePart", this._particleHolder, new PIXI.Point(0.7, 1));
            this._camera.addLayer("mid", this._midHolder, new PIXI.Point(0.5, 1));
            this._camera.addLayer("midBk", this._midBackHolder, new PIXI.Point(0.4, 1));

            this._camera.trackTarget({ x: this._startPos.x + 250, y: this._startPos.y }, true);
        }
    }, {
        key: "addStars",
        value: function addStars() {

            for (var i = 1; i < this._objects.length; i++) {

                // const rand = Math.random();
                //  console.log(rand + " : " + this.starChance + " : " + (this.starChance < rand));


                if (this._objects[i].type === "pit") continue;
                if (this._objects[i - 1] && (this._objects[i - 1].type === "balloons" || this._objects[i - 1].type === "pit")) continue;

                if (this._objects[i].type === "balloons") {
                    //jump apex
                    var star = createSprite("star", this._gameHolder);
                    star.x = this._objects[i].x;
                    var dist = this._objects[i].x - this._objects[i - 1].x;
                    star.x -= dist * 0.5;
                    star.y = this._objects[i].y - (dist * this._bounceHeightFactor - 75) * 1.5;
                    if (star.y > this._floorPosition.y - 50) {
                        star.visible = false;
                        star.collected = true;
                    }
                    this._stars.push(star);

                    //mid way up
                    star = createSprite("star", this._gameHolder);
                    star.x = this._objects[i].x;
                    star.x -= dist * 0.75;
                    star.y = this._objects[i].y - (dist * this._bounceHeightFactor * 0.8 - 75) * 1.5;

                    if (star.y > this._floorPosition.y - 50) {
                        star.visible = false;
                        star.collected = true;
                    }
                    this._stars.push(star);

                    //mid way down
                    star = createSprite("star", this._gameHolder);
                    star.x = this._objects[i].x;
                    star.x -= dist * 0.25;
                    star.y = this._objects[i].y - (dist * this._bounceHeightFactor * 0.8 - 25) * 1.5;

                    if (star.y > this._floorPosition.y - 50) {
                        star.visible = false;
                        star.collected = true;
                    }
                    this._stars.push(star);
                } else if (Math.random() < this.starChance) {
                    //jump apex
                    var _star = createSprite("star", this._gameHolder);
                    _star.x = this._objects[i].x;
                    var _dist = this._objects[i].x - this._objects[i - 1].x;
                    _star.x -= _dist * 0.5;
                    _star.y = this._objects[i].y - _dist * this._bounceHeightFactor - 50;
                    if (_star.y > this._floorPosition.y - 50) {
                        _star.visible = false;
                        _star.collected = true;
                    }
                    this._stars.push(_star);

                    //mid way up
                    _star = createSprite("star", this._gameHolder);
                    _star.x = this._objects[i].x;
                    _star.x -= _dist * 0.75;
                    _star.y = this._objects[i].y - _dist * this._bounceHeightFactor * 0.8 - 75;

                    if (_star.y > this._floorPosition.y - 50) {
                        _star.visible = false;
                        _star.collected = true;
                    }
                    this._stars.push(_star);

                    //mid way down
                    _star = createSprite("star", this._gameHolder);
                    _star.x = this._objects[i].x;
                    _star.x -= _dist * 0.25;
                    _star.y = this._objects[i].y - _dist * this._bounceHeightFactor * 0.8 - 75;

                    if (_star.y > this._floorPosition.y - 50) {
                        _star.visible = false;
                        _star.collected = true;
                    }
                    this._stars.push(_star);
                }
            }
        }
    }, {
        key: "initObjects",
        value: function initObjects() {

            //--binds--//
            addDeco = addDeco.bind(this);
            addObstacles = addObstacles.bind(this);
            addBg = addBg.bind(this);

            addDeco();
            // addObstacles();
            addBg();

            var banner = createSprite("banner_start", this._gameHolder);
            banner.y = p3.View.height * 0.5 + 25;
            banner.x = -325;

            var txt = void 0;
            if (_Common2.default.language === "ar" || _Common2.default.language === "ru" || _Common2.default.language === "tr") {
                txt = p3.simpleText(_Common2.default.copy.start[_Common2.default.language], "arial", 120, null, 0xd21402);
            } else {
                txt = new PIXI.extras.BitmapText(_Common2.default.copy.start[_Common2.default.language], {
                    font: "95px Ziclets",
                    align: "center",
                    tint: 0xd21402
                });
            }

            txt.anchor.set(0.5);
            txt.x = -90;
            txt.y = 110;
            txt.skew.y = _Common2.default.deg2rad(2);
            txt.scale.x = 0.45;
            txt.rotation = _Common2.default.deg2rad(4);
            banner.addChild(txt);

            if (_Common2.default.language !== "en") {
                txt.scale.set(0.25);
                txt.y += 25;
                txt.x -= 5;
                txt.rotation = _Common2.default.deg2rad(6);
            }

            var cannonBk = createSprite("cannon_back", this._gameHolder);
            var cannonMain = createSprite("cannon_main", this._gameHolder);
            var cannonMainFront = createSprite("cannon_main_2", cannonMain);
            var cannonFront = createSprite("cannon_front", this._gameHolder);
            cannonBk.position.set(this._startPos.x - 130, this._startPos.y - 75);
            cannonMain.position.set(this._startPos.x - 175, this._startPos.y + 25);
            cannonFront.position.set(this._startPos.x - 130, this._startPos.y - 75);
            cannonBk.scale.set(1.5);
            cannonMain.scale.set(1.5);
            cannonFront.scale.set(1.5);

            var dotLine = createSprite("dotted_line", cannonMain);
            dotLine.anchor.set(0, 0.5);
            dotLine.visible = false;
            dotLine.position.set(75, 0);
            cannonMain.tutLine = dotLine;

            var finger = createSprite("hand_big", dotLine);
            finger.anchor.set(0, 0.5);
            finger.scale.set(0.75);
            finger.x = dotLine.width;
            finger.y = finger.height * 0.5;

            var dirArrow = createSprite("tutorial_arrow", this._gameHolder);
            dirArrow.anchor.set(0.5);
            dirArrow.y = p3.View.height - 75;
            dirArrow.x = p3.View.width * 0.5 + 125;
            dirArrow.scale.y = -1;
            dirArrow.visible = false;
            this._tutArrow = dirArrow;

            //--add in the alien--//
            this._alien = new PIXI.spine.Spine(_Common2.default.assets.getSpineData("alien"));
            this._alien.skeleton.setToSetupPose();
            this._alien.autoUpdate = true;
            this._alien.state.setAnimation(0, "idle_0", true);
            this._alien.y = -1550;
            this._alien.x = 125;
            this._alien.scale.set(0.5);

            this._gameHolder.addChild(this._alien);

            disp.push(this._alien);

            //give alien a lil animation on y
            //TweenMax.to(this._alien, 3, {y: this._alien.y + 250, yoyo: true, repeat: -1, ease: Power0.easeNone});
            //tween his x offset too
            //TweenMax.to(this._alienOffset, 3, {x: 150, yoyo: true, repeat: -1, ease: Power0.easeNone});

            this._happo = new PIXI.spine.Spine(_Common2.default.assets.getSpineData("stunt_happo_flying"));
            this._happo.skeleton.setToSetupPose();
            this._happo.autoUpdate = true;
            this._happo.state.setAnimation(0, "flight" + Math.ceil(Math.random() * 9), true);
            this._happo.scale.set(0.35);
            this._happo.position.set(this._startPos.x, this._startPos.y /* - 75*/);
            this._happo.visible = false;
            this._gameHolder.addChild(this._happo);
            this._cannon = cannonMain;
            this._cannonMainFront = cannonMainFront;
            this._canFront = cannonFront;
            cannonMain.anchor.set(0.4, 0.5);
            cannonMainFront.anchor.set(0.4, 0.5);

            this._happo.state.data.defaultMix = 0.5;
            this._happo.killRotate = false;
            this._happo.finalAnim = false;

            //set the animation mix duration default
            // this._view.state.data.defaultMix = 0.25;

            //setup happos velocities
            this._happo.dx = 0;
            this._happo.dy = 0;
            this._happo.rotSpeed = 0;

            //setup flow filtert
            this.glowFilter = [new PIXI.filters.GlowFilter(10, 0, 0, 0xffffff, 0.25)];
            // console.log(this.glowFilter[0].uniforms);
            TweenMax.to(this.glowFilter[0].uniforms, 0.5, {
                outerStrength: 4,
                yoyo: true,
                repeat: -1,
                ease: Power0.easeNone
            });
            // this._cannon.filters = this.glowFilter;
            disp.push(this._happo);

            //animate start
            TweenMax.to(cannonMain, 3, { rotation: _Common2.default.deg2rad(-30), ease: Elastic.easeOut, delay: 0.5 });

            function addObstacles() {
                //--min and max distance between obstacles and total obs--//
                var numObstacles = this.basicLength + Math.round(Math.random() * this.randomLength);
                var slowDown = 1;
                var distFromStart = 0,
                    obs = void 0,
                    rand = void 0;
                for (var i = 0; i < numObstacles; i++) {
                    if (i > 2) {
                        if (i < numObstacles - 4) {

                            var lastType = this._objects[this._objects.length - 1].type;

                            if (lastType !== "balloons") {

                                if (lastType === "trampoline" || lastType === "spring" || lastType === "spring_2" || lastType === "float") {

                                    obs = createSprite("balloons", this._gameHolder);
                                    obs.type = "balloons";
                                    slowDown = 1;
                                } else {
                                    rand = Math.floor(Math.random() * (Object.keys(this.objTextures).length + this.chanceNoneObs));
                                    if (rand < Object.keys(this.objTextures).length) {
                                        rand = Math.floor(Math.random() * Object.keys(this.objTextures).length);
                                        obs = createSprite(this.objTextures[rand], this._gameHolder);
                                        obs.type = this.objTextures[rand];
                                        slowDown = 1;
                                    } else {
                                        obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                                        obs.type = "none";
                                        obs.height = 45;
                                    }
                                }
                            } else if (Math.random() < 0.5) {
                                obs = createSprite("balloons", this._gameHolder);
                                obs.type = "balloons";
                                slowDown = 1;
                            } else {
                                obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                                obs.type = "none";
                                obs.height = 45;
                            }
                        } else {
                            obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                            obs.type = "none";
                            obs.height = 45;
                        }
                    } else {
                        obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                        obs.type = "none";
                        obs.height = 45;
                    }

                    //console.warn(this._objects[i - 1].type);
                    if (i > 0) {
                        var dist = (this.bounceFactors[this._objects[this._objects.length - 1].type] * 100 + Math.round(Math.random() * this.randomObsDist)) * slowDown;
                        distFromStart += dist;
                        if (slowDown > 0.2) {
                            slowDown -= 0.25;
                        } else {
                            //end of run
                            return;
                        }
                        if (Math.random() < 0.25) {
                            rand = Math.floor(Math.random() * Object.keys(this.objTextures).length);
                            var dummyObj = createSprite(this.objTextures[rand], this._gameHolder);
                            dummyObj.position.set(distFromStart - 125 + Math.random() * 200, this._floorPosition.y + 50);
                            dummyObj.anchor.set(0.5, 1);
                        }
                    }
                    obs.anchor.set(0.5, 1);
                    obs.position.set(distFromStart, this._floorPosition.y + 50);
                    if (obs.type === "balloons") {
                        obs.y = Math.random() * -350 - 150;
                    }
                    obs.visible = false;
                    this._objects.push(obs);
                }
            }

            function addDeco() {

                var floor = new PIXI.extras.TilingSprite(_Common2.default.assets.getTexture("ground"), this.tileSize * 8, 550 / 2);
                floor.position.x = -p3.View.width;
                floor.position.y = p3.View.height - 75;
                floor.uvTransform.clampMargin = 0;
                floor.uvTransform.clampOffset = -1;
                floor.scale.y = 1.5;
                //  floor.visible = false;

                var mounts = [];
                for (var i = 0; i < 5; i++) {
                    var sp = createSprite("mountains_2_bg", this._bgHolder);
                    sp.scale.set(2);
                    sp.x = -sp.width + i * sp.width;
                    sp.y = p3.View.height * 0.5 - 400;
                    mounts.push(sp);
                }

                var mid = new PIXI.extras.TilingSprite(_Common2.default.assets.getTexture("mid_ground"), this.tileSize * 6, 500 / 2);
                mid.position.x = -p3.View.width;
                mid.position.y = p3.View.height - 115;
                mid.uvTransform.clampMargin = 0;
                mid.uvTransform.clampOffset = -1;
                // mid.visible = false;

                var midBk = new PIXI.extras.TilingSprite(_Common2.default.assets.getTexture("mid_ground_2"), this.tileSize * 6, 102);
                midBk.position.x = -p3.View.width;
                midBk.position.y = p3.View.height - 180;
                midBk.uvTransform.clampMargin = 0;
                midBk.uvTransform.clampOffset = -1;
                //  midBk.visible = false;

                disp.push(floor, mid, midBk);

                this.floorTiles = floor;
                this.mountainTiles = mounts;
                this.midTiles = mid;
                this.midBkTiles = midBk;

                this._gameHolder.addChild(floor);

                this._midHolder.addChild(mid);
                this._midBackHolder.addChild(midBk);

                this._decos = [];
                this._decosMG = [];
                this._decosFG = [];
                this._decosBG = [];

                var obj = void 0;
                for (var _i15 = 0; _i15 < 2; _i15++) {
                    var rand = Math.round(Math.random() + 1);
                    obj = createSprite("rock_" + rand, this._bgHolder);
                    obj.x = _i15 * 2000 + Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 + Math.round(Math.random() * 75) + 75;
                    obj.y += Math.random() * 50;
                    obj.scale.set(Math.random() * 0.1 + 0.5);
                    this._decosBG.push(obj);
                }

                for (var _i16 = 0; _i16 < 2; _i16++) {
                    obj = createSprite("bush_midground", this._bgHolder);
                    obj.x = _i16 * 2000 + Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 + Math.round(Math.random() * 75) + 75;
                    obj.y += Math.random() * 50;
                    obj.scale.set(Math.random() * 0.1 + 0.5);
                    this._decosBG.push(obj);
                }

                for (var _i17 = 0; _i17 < 2; _i17++) {
                    obj = createSprite("tree_midground", this._bgHolder);
                    obj.x = _i17 * 2000 + Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 + Math.round(Math.random() * 75) + 75;
                    obj.y -= Math.random() * 50;
                    obj.scale.set(Math.random() * 0.1 + 0.5);
                    this._decosBG.push(obj);
                }

                for (var _i18 = 0; _i18 < 1; _i18++) {
                    obj = createSprite("rock_fg", this._fgHolder);
                    obj.anchor.y = 1;
                    obj.x = _i18 * 2000 + Math.random() * 1000;
                    obj.y = p3.View.height + obj.height;
                    obj.scale.set(Math.random() * 0.25 + 0.75);
                    obj.fg = true;
                    this._decosFG.push(obj);
                }
                for (var _i19 = 0; _i19 < 1; _i19++) {
                    var _rand2 = Math.round(Math.random() + 1);
                    obj = createSprite("rock_" + _rand2, this._midHolder);
                    obj.x = _i19 * 2000 + Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 + Math.round(Math.random() * 75) + 200;
                    obj.scale.set(Math.random() * 0.25 + 0.75);
                    this._decosMG.push(obj);
                }
                var midDisp = [];
                for (var _i20 = 0; _i20 < 1; _i20++) {
                    obj = createSprite("tree_midground", this._midBackHolder);
                    obj.x = _i20 * 2000 + Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 + 315;
                    //obj.scale.set((Math.random() * 0.25) + 0.75);
                    obj.anchor.set(0.5, 1);
                    obj.scale.set(2);
                    midDisp.push(obj);
                    this._decosMG.push(obj);
                }
                for (var _i21 = 0; _i21 < 1; _i21++) {
                    obj = createSprite("bush_midground", this._midBackHolder);
                    obj.x = _i21 * 2000 + Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 + 150;
                    //obj.scale.set((Math.random() * 0.25) + 0.75);
                    midDisp.push(obj);
                    this._decosMG.push(obj);
                }

                //randomises draw order
                midDisp = _Common2.default.shuffleArr(midDisp);
                for (var _i22 = 0; _i22 < midDisp.length; _i22++) {
                    this._midBackHolder.addChild(midDisp[_i22]);
                }

                //--add in clouds--//
                for (var _i23 = 0; _i23 < 8; _i23++) {
                    obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._bgHolder);
                    obj.x = _i23 * 2000 + Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 - 650 - Math.random() * 100;
                    //obj.scale.set((Math.random() * 0.25) + 0.75);
                    obj.scale.set(Math.random() * 0.25 + 1);
                    this._clouds.push(obj);
                    midDisp.push(obj);
                    this._decosBG.push(obj);
                }

                //--add in clouds--//
                for (var _i24 = 0; _i24 < 8; _i24++) {
                    obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._bgHolder);
                    obj.x = _i24 * 2000 + Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 - 100 - Math.random() * 200;
                    //obj.scale.set((Math.random() * 0.25) + 0.75);
                    obj.scale.set(Math.random() * 0.25 + 0.75);
                    this._clouds.push(obj);
                    midDisp.push(obj);
                    this._decosBG.push(obj);
                }

                //--add in clouds high--//
                for (var _i25 = 0; _i25 < 8; _i25++) {
                    obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._bgHolder);
                    obj.x = _i25 * 1000 - Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 - 1000;
                    obj.scale.set(Math.random() * 1.75 + 0.75);
                    this._clouds.push(obj);
                    midDisp.push(obj);
                    this._decosBG.push(obj);
                }

                //--add in clouds high--//
                for (var _i26 = 0; _i26 < 8; _i26++) {
                    obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._bgHolder);
                    obj.x = _i26 * 2000 - Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 - 2000;
                    obj.scale.set(Math.random() * 1.75 + 0.75);
                    this._clouds.push(obj);
                    midDisp.push(obj);
                    this._decosBG.push(obj);
                }

                //--add in clouds high--//
                for (var _i27 = 0; _i27 < 8; _i27++) {
                    obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._bgHolder);
                    obj.x = _i27 * 2000 - Math.random() * 1000;
                    obj.y = p3.View.height * 0.5 - 2500 - Math.random() * 1000;
                    obj.scale.set(Math.random() * 1.75 + 0.75);
                    this._clouds.push(obj);
                    midDisp.push(obj);
                    this._decosBG.push(obj);
                }

                //--add in clouds high--//
                for (var _i28 = 0; _i28 < 8; _i28++) {
                    obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._bgHolder);
                    obj.x = _i28 * 250 + Math.random() * 250;
                    obj.y = p3.View.height * 0.5 - 3000 - Math.random() * 2000;
                    obj.scale.set(Math.random() * 1.75 + 0.75);
                    this._clouds.push(obj);
                    midDisp.push(obj);
                    this._decosBG.push(obj);
                }

                //--add in clouds high--//
                for (var _i29 = 0; _i29 < 8; _i29++) {
                    obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._bgHolder);
                    obj.x = _i29 * 250 + Math.random() * 250;
                    obj.y = p3.View.height * 0.5 - 3000 - Math.random() * 500;
                    obj.scale.set(Math.random() * 1.75 + 0.75);
                    this._clouds.push(obj);
                    midDisp.push(obj);
                    this._decosBG.push(obj);
                }

                //--add in clouds front--//
                for (var _i30 = 0; _i30 < 8; _i30++) {
                    obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._gameHolder);
                    obj.x = _i30 * 250 + Math.random() * 250;
                    obj.y = p3.View.height * 0.5 - 1200 + Math.random() * 350;
                    obj.scale.set(Math.random() * 2.75 + 1.75);
                    obj.alpha = 0.5;
                    midDisp.push(obj);
                    this._decos.push(obj);
                }

                //--add in clouds front--//
                for (var _i31 = 0; _i31 < 8; _i31++) {
                    obj = createSprite("cloud_m_" + Math.ceil(Math.random() * 3), this._fgHolder);
                    obj.x = _i31 * 250 + Math.random() * 250;
                    obj.y = p3.View.height * 0.5 - 1200 + Math.random() * 350;
                    obj.scale.set(Math.random() * 2.75 + 1.75);
                    obj.alpha = 0.5;
                    midDisp.push(obj);
                    this._decosFG.push(obj);
                    obj.fg = true;
                }

                //--add happos--//
                for (var _i32 = 0; _i32 < 10; _i32++) {
                    obj = this.createHappo();
                    obj.x = _i32 * 10000 + 125;
                    obj.shadow.position.set(obj.x, obj.y - 30);
                    if (obj.type === "ballerina") obj.shadow.y -= 10;else if (obj.type === "worker") obj.shadow.y -= 5;
                }
            }

            function addBg() {
                var _this10 = this;

                //uses a tiling sprite for background
                var bgTiles = createSprite("sky");
                _Common2.default.displayObjs.pop(); //remove sky from culling array because it is moved with the player

                bgTiles.width = p3.View.width * 2;
                bgTiles.height = p3.View.height * 2.5;
                bgTiles.y -= 20;

                bgTiles.interactive = true;
                bgTiles.hitArea = new PIXI.Rectangle(0, 0, p3.View.width, p3.View.height);
                bgTiles.mousedown = bgTiles.touchstart = this.inputDown.bind(this);
                bgTiles.mouseup = bgTiles.mouseupoutside = bgTiles.touchend = bgTiles.touchendoutside = function () {

                    if (_this10._launched || _Common2.default.paused || _this10.justUnpaused || !_this10._running || _this10.skidding || _this10._gameComplete || !_this10._inputData) return;

                    _Common2.default.audio.playSound("sfx_happo_fling_0" + Math.round(Math.random()));
                    _Common2.default.audio.playSound("sfx_cannon_fire_0" + Math.round(Math.random()));

                    _this10.starterHappo.visible = false;
                    _this10._starBtnBack.visible = true;

                    _this10._cannonEmitter.emit = true;
                    _this10._cannonEmitter2.emit = true;

                    var rotation = _this10._cannon.rotation;
                    // if (rotation > -0.3) this.lowLaunch = true;
                    if (rotation < -0.7) {
                        _this10._happo.x -= 85;
                        _this10._happo.y -= 25;
                    }

                    var mousePos = _this10._inputData.getLocalPosition(_this10);
                    var length = _Common2.default.distance(_this10._happo.x, _this10._happo.y, mousePos.x, mousePos.y);

                    TweenMax.from(_this10._happo.scale, 0.25, { x: 0.15, y: 0.15, ease: Power1.easeOut });
                    _this10._happo.rotation = rotation;

                    // for (let i = 0; i < this._objects.length; i++) {
                    //  this._objects[i].x += Math.abs(rotation * 6000);
                    //   this._objects[i].visible = true;
                    //   }
                    // this.addStars();
                    // this._objects.reverse();
                    _this10._happo.visible = true;
                    _this10._inputData = null;
                    _this10._cannon.rotation = rotation;
                    _this10._launched = true;
                    //  this.runCourse();
                    delay(function () {
                        _this10._camera.trackTarget(_this10._trackTarg);
                        _this10._camera.trackEase = 0.01;
                        TweenMax.to(_this10._camera, 0.5, {
                            trackEase: _this10.maxCamEase,
                            ease: Power0.easeNone
                        });
                    }, 0.25);

                    //--calculate happos dx , dy--//
                    var dx = Math.cos(rotation) * length;
                    var dy = Math.sin(rotation) * length;

                    // console.log(dx);
                    // console.log(dy);

                    _this10._happo.dx = dx / 10;
                    _this10._happo.dy = dy / 10;

                    _this10._gameHolder.addChild(_this10._cannon);
                };
                this._back.addChild(bgTiles);
                this._sky = bgTiles;
            }
        }
    }, {
        key: "inputDown",
        value: function inputDown(event) {

            if (_Common2.default.paused || this.justUnpaused || this._gameComplete) return;

            if (this._cannon.tutLine.visible) {
                this._happo.state.timeScale = 1;
                TweenMax.resumeAll();
                _Common2.default.paused = false;
                this.starFinger.visible = false;
                this._cannon.tutLine.visible = false;
                this._tutArrow.visible = false;
                this._running = true;
                if (this.tutTween) {
                    this.tutTween.kill();
                }
                this._finishedIntro = true;
            }

            if (this.starFinger && this.starFinger.visible) {
                this.starFinger.visible = false;
                this._running = true;
                this._happo.state.timeScale = 1;
            }

            this._inputData = event.data;

            if (this._launched && this._starsCollected > 19) {
                if (Math.random() > 0.5) {
                    _Common2.default.audio.playSound("sfx_happos_ooh_00");
                } else {
                    _Common2.default.audio.playSound("sfx_happos_cheer_00");
                }
                this.relaunch();

                if (event.target === this._starBtnBack) {
                    _Common2.default.audio.playSound("sfx_btn_press_00");
                    TweenMax.to(this._starBtnBack.scale, 0.25, {
                        x: 0.9,
                        y: 0.9,
                        yoyo: true,
                        repeat: 1,
                        ease: Power0.easeNone
                    });
                }
            }
        }
    }, {
        key: "fixCourse",
        value: function fixCourse() {
            for (var i = this._objects.length - 2; i < this._objects.length; i++) {
                this._objects[i].x = this._objects[i - 1].x + 600;
            }
        }
    }, {
        key: "createHappo",
        value: function createHappo() {
            var shadow = createSprite("shadow", this._gameHolder);
            var rand = Math.ceil(Math.random() * 4);
            var obj = createSprite("happo_" + rand, this._gameHolder);
            obj.anchor.y = 1;
            obj.scale.set(0.7);
            obj.y = p3.View.height + obj.height - 115;
            obj.tween = TweenMax.to(obj.scale, 1, {
                x: obj.scale.x + 0.02,
                y: obj.scale.y - 0.02,
                ease: Power0.easeNone,
                yoyo: true,
                repeat: -1,
                repeatDelay: 0.15 + Math.random * 0.2,
                delay: Math.random()
            });
            this._happos.push(obj);
            obj.shadow = shadow;
            shadow.scale.set(0.5);
            if (rand === 4) {
                obj.type = "ballerina";
            } else if (rand === 1) {
                obj.type = "worker";
            }
            return obj;
        }
    }, {
        key: "relaunch",
        value: function relaunch() {
            var _this11 = this;

            //--emit stars for a few seconds--//
            this._boostReadyEmitter.emit = true;
            delay(function () {
                _this11._boostReadyEmitter.emit = false;
            }, 2, this);

            this._happo.finalAnim = false;
            this._happo.killRotate = false;

            //absolute the value and negate for dy so we are always going up with lots of force after a boost
            //this._happo.dy = Math.abs(this._happo.dy);

            if (this._happo.dy > 0) this._happo.dy = 0;

            this._happo.dx += this._boostPower * 0.75;
            this._happo.dy -= this._boostPower;

            this._starsCollected -= 20;
            //this._starsText.text = "" + this._starsCollected;
            // this._fillMask.x = -225 + (150 / 20) * (this._starsCollected % 20);
            //make bar full if we still got more than 20 stars
            if (this._starsCollected >= 20) {
                //  this._fillMask.x = -225 + 150;
            } else {
                //otherwise set bar animations and particles to stop
                this._starBtnFront.texture = _Common2.default.assets.getTexture("btn_boost_off");
                this._starTween.kill();
                this._starBtnFront.scale.set(1);
                this._starParticles.emit = false;
                // this._boostReadyEmitter.emit = false;
                this._boostReadyEmitterHappo.emit = false;
                //  this._happo.filters = null;
                this._starBtnBack.filters = null;
            }
        }

        /**
         * @deprecated
         */

    }, {
        key: "relaunchOld",
        value: function relaunchOld() {
            //console.warn("relaunching");
            var dist = this._starsCollected * 55;
            this._happo.state.setAnimation(0, "flightboost", true);
            this._happo.scale.set(0.3);
            this._happo.rotation = _Common2.default.deg2rad(-25);
            this.relaunched = true;

            if (this._objects.length < 4) {
                console.log("extending course");
                // this._objects = [];
                this.extendObstacles(10 + Math.ceil(Math.random() * 5));
            } else {
                console.log("popping front obs");
                this._objects.pop();
                this._objects.pop();
            }

            this._speed = this._speedMax;

            for (var i = 0; i < this._objects.length; i++) {
                this._objects[i].x += dist;
            }
            for (var _i33 = 1; _i33 < this._objects.length; _i33++) {
                this._objects[_i33].x += 800;
            }
            var index = 0;
            for (var _i34 = 0; _i34 < this._stars.length; _i34++) {
                if (!this._stars[_i34].collected) {
                    index = _i34;
                    break;
                }
            }
            for (var _i35 = index + 5; _i35 < this._stars.length; _i35++) {
                this._stars[_i35].x += dist + 800;
            }
            this._starsCollected -= 20;
            this._starsText.text = "" + this._starsCollected;
            this._fillMask.x = -225 + 150 / 20 * (this._starsCollected % 20);
            if (this._starsCollected >= 20) this._fillMask.x = -225 + 150; //make bar full
            else {
                    this._starTween.kill();
                    this._starIcon.scale.set(1);
                    this._starParticles.emit = false;
                    this._boostReadyEmitter.emit = false;
                }

            this.runCourse();
        }
    }, {
        key: "extendObstacles",
        value: function extendObstacles(num) {

            this._objects = [];
            //   this._oldObjects.reverse();
            var numObstacles = num;
            var distFromStart = this._happo.x,
                obs = void 0,
                rand = void 0;

            for (var i = 0; i < numObstacles; i++) {

                if (i > 1) {
                    if (i < numObstacles - 4) {

                        //  console.log(this._objects[this._objects.length - 1].type);
                        var lastType = this._objects[this._objects.length - 1].type;

                        if (lastType !== "balloons") {

                            if (lastType === "trampoline" || lastType === "spring" || lastType === "spring_2" || lastType === "float") {

                                obs = createSprite("balloons", this._gameHolder);
                                obs.type = "balloons";
                            } else {
                                rand = Math.floor(Math.random() * (Object.keys(this.objTextures).length + this.chanceNoneObs));
                                if (rand < Object.keys(this.objTextures).length) {
                                    rand = Math.floor(Math.random() * Object.keys(this.objTextures).length);
                                    obs = createSprite(this.objTextures[rand], this._gameHolder);
                                    obs.type = this.objTextures[rand];
                                } else {
                                    obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                                    obs.type = "none";
                                    obs.height = 45;
                                }
                            }
                        } else if (Math.random() < 0.35) {
                            obs = createSprite("balloons", this._gameHolder);
                            obs.type = "balloons";
                        } else {
                            obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                            obs.type = "none";
                            obs.height = 45;
                        }
                    } else {
                        obs = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
                        obs.type = "none";
                        obs.height = 45;
                    }
                } else {
                    obs = createSprite("balloons", this._gameHolder);
                    obs.type = "balloons";
                }

                if (i > 0) {
                    //todo - this should ensure that the last few obs are type "none" and then set exact distances
                    var dist = this.bounceFactors[this._objects[this._objects.length - 1].type] * 100 + Math.round(Math.random() * this.randomObsDist);
                    distFromStart += dist;
                }
                obs.anchor.set(0.5, 1);
                obs.position.set(distFromStart, this._floorPosition.y + 50);
                if (obs.type === "balloons") obs.y = -450 - Math.random() * 350;
                this._objects.push(obs);
            }

            this.addStars();
            this._objects.reverse();
        }
    }, {
        key: "initParticles",
        value: function initParticles() {
            var config = _Common2.default.assets.getJSON("particles_cannon_1");
            this._cannonEmitter = new PIXI.particles.Emitter(this._gameHolder, [_Common2.default.assets.getTexture("smoke")], config);
            this._cannonEmitter.emit = false;
            //this._cannonEmitter.updateSpawnPos(this._cannon.x, this._cannon.y);
            this._cannonEmitter.updateOwnerPos(this._cannon.x, this._cannon.y);
            this._particleEmitters.push(this._cannonEmitter);

            config = _Common2.default.assets.getJSON("particle_cannon_directional_blast");
            this._cannonEmitter2 = new PIXI.particles.Emitter(this._gameHolder, [_Common2.default.assets.getTexture("smoke")], config);
            this._cannonEmitter2.emit = false;
            //this._cannonEmitter2.updateSpawnPos(this._cannon.x, this._cannon.y);
            this._cannonEmitter2.updateOwnerPos(this._cannon.x, this._cannon.y);
            this._particleEmitters.push(this._cannonEmitter2);

            config = _Common2.default.assets.getJSON("particles_splash_water");
            var emitter = new PIXI.particles.Emitter(this._particleHolder, [_Common2.default.assets.getTexture("particle_splash_water_01"), _Common2.default.assets.getTexture("particle_splash_water_02"), _Common2.default.assets.getTexture("particle_splash_water_03"), _Common2.default.assets.getTexture("particle_splash_water_04")], config);
            emitter.emit = false;
            this._waterEmitter = emitter;

            config = _Common2.default.assets.getJSON("particles_splash_mud");
            emitter = new PIXI.particles.Emitter(this._particleHolder, [_Common2.default.assets.getTexture("particle_splash_mud_01"), _Common2.default.assets.getTexture("particle_splash_mud_02"), _Common2.default.assets.getTexture("particle_splash_mud_03")], config);
            emitter.emit = false;
            this._mudEmitter = emitter;

            config = _Common2.default.assets.getJSON("particles_character_boost_ready");
            emitter = new PIXI.particles.Emitter(this._gameHolder, [_Common2.default.assets.getTexture("part_star")], config);
            emitter.emit = false;
            this._boostReadyEmitter = emitter;

            // this._gameHolder.addChild(this._happo);

            config = _Common2.default.assets.getJSON("particles_dust_ground");
            //num particles 25
            //radius 30
            //endSize 0.4
            // config.radius = 25;
            //  config.
            emitter = new PIXI.particles.Emitter(this._gameHolder, [_Common2.default.assets.getTexture("smoke")], config);
            emitter.emit = false;
            this._dustEmitter = emitter;

            var extraContainer = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
            extraContainer.anchor.set(0.5);
            var anotherContainer = createSprite(PIXI.Texture.EMPTY, this._gameHolder);
            anotherContainer.anchor.set(0.5);
            extraContainer.addChild(anotherContainer);
            anotherContainer.scale.set(2);

            this.extraContainer = extraContainer;
            this._gameHolder.addChild(extraContainer);

            config = _Common2.default.assets.getJSON("particles_boostmeter");
            emitter = new PIXI.particles.Emitter(anotherContainer, [_Common2.default.assets.getTexture("part_star")], config);
            emitter.emit = false;
            this._boostReadyEmitterHappo = emitter;

            this._particleEmitters.push(this._waterEmitter, this._mudEmitter, this._boostReadyEmitter, this._dustEmitter /*, this._boostReadyEmitterHappo*/);
        }
    }, {
        key: "initUI",
        value: function initUI() {
            var _this12 = this;

            var createPauseScreen = function createPauseScreen() {

                var screen = createSprite("panel_help", _this12._uIntHolder);
                screen.anchor.y = 0.5;
                screen.y = p3.View.height * 0.5;

                var muteClick = function muteClick() {
                    _Common2.default.isMute = !_Common2.default.isMute;
                    _Common2.default.audio.mute(_Common2.default.isMute);
                    if (!_Common2.default.isMute) _this12.soundBtn.icon.texture = _Common2.default.assets.getTexture("icon_sound_on");else _this12.soundBtn.icon.texture = _Common2.default.assets.getTexture("icon_sound_off");
                };
                _this12.soundBtn = _Common2.default.createButton(p3.View.width * 0.5 - 75, -p3.View.height * 0.5 + 65, "small", muteClick, _this12, screen, "icon_sound_off");
                if (!_Common2.default.isMute) _this12.soundBtn.icon.texture = _Common2.default.assets.getTexture("icon_sound_on");

                var homeClick = function homeClick() {
                    _this12.signals.home.dispatch(_this12);
                };
                var btnHome = _Common2.default.createButton(-p3.View.width * 0.5 + 75, -p3.View.height * 0.5 + 65, "small", homeClick, _this12, screen, "icon_home");

                var btnPlay = _Common2.default.createButton(p3.View.width * 0.5 - 100, p3.View.height * 0.5 - 100, "big", _this12.pauseClick, _this12, screen, "icon_play");
                var btnReplay = _Common2.default.createButton(-p3.View.width * 0.5 + 100, p3.View.height * 0.5 - 100, "big", function () {
                    _this12.signals.previous.dispatch(_this12);
                }, _this12, screen, "icon_replay");

                //add help screens
                var frames = void 0;
                if (!p3.Device.isMobile) {
                    frames = [createSprite("tutorial_fr_1_desktop", screen), createSprite("tutorial_fr_2_desktop", screen), createSprite("tutorial_fr_3", screen)];
                } else {
                    frames = [createSprite("tutorial_fr_1_mobile", screen), createSprite("tutorial_fr_2_mobile", screen), createSprite("tutorial_fr_3", screen)];
                }

                for (var i in frames) {
                    frames[i].anchor.set(0.5);
                    // frames[i].y += 35;
                    frames[i].visible = false;
                }

                var txtFrames = [],
                    pips = [];
                for (var _i36 = 0; _i36 < 3; _i36++) {
                    var append = void 0;
                    if (!p3.Device.isMobile) {
                        append = "_desk";
                    } else {
                        append = "_mob";
                    }

                    var textConfig = {
                        fontFamily: "arial",
                        fontSize: "27px",
                        fill: 0x6a9bd5,
                        align: "center",
                        wordWrap: true,
                        wordWrapWidth: screen.width - 290
                    };

                    if (_Common2.default.language !== "en") {
                        textConfig.fontSize = "22px";
                    }

                    var txt = void 0;

                    txt = new PIXI.Text(_Common2.default.copy["help_fr_" + (_i36 + 1) + "_desk"][_Common2.default.language], textConfig);
                    txt.anchor.set(0.5);
                    txtFrames.push(txt);
                    txt.y = screen.height * 0.5 - 110;
                    txt.visible = false;
                    var pip = createSprite("pip_on", screen);
                    pip.y = screen.height * 0.5 - 38;
                    pip.visible = false;
                    pip.anchor.set(0.5);
                    pips.push(pip);
                    screen.addChild(txt);
                }

                pips[0].x = -55;
                pips[0].visible = true;
                pips[pips.length - 1].x = 55;

                var frNum = 0;
                var changeFrame = function changeFrame(dir) {
                    frames[frNum].visible = false;
                    txtFrames[frNum].visible = false;
                    pips[frNum].visible = false;
                    frNum += dir;
                    if (frNum > frames.length - 1) frNum = 0;
                    if (frNum < 0) frNum = frames.length - 1;
                    frames[frNum].visible = true;
                    txtFrames[frNum].visible = true;
                    pips[frNum].visible = true;
                };
                changeFrame(0);

                var leftPanel = createSprite("panel_arrow_holder_l", screen);
                var rightPanel = createSprite("panel_arrow_holder_r", screen);

                var btnLeft = _Common2.default.createButton(-screen.width * 0.5 + 75, 45, "small", function () {
                    changeFrame(-1);
                }, _this12, screen, "icon_next");
                btnLeft.icon.scale.x = -1;

                var btnRight = _Common2.default.createButton(screen.width * 0.5 - 75, 45, "small", function () {
                    changeFrame(1);
                }, _this12, screen, "icon_next");

                _this12.pauseScreen = screen;
                screen.visible = false;

                leftPanel.x = btnLeft.x - 2;
                //leftPanel.y = btnLeft.y + btnLeft.height * 0.5 + 15;
                rightPanel.x = btnRight.x + 2;
                leftPanel.y = rightPanel.y = btnRight.y - btnLeft.height * 0.5 - 15;
                //leftPanel.scale.x = -1;


                _this12.leftPanel = leftPanel;
                _this12.leftBtn = btnLeft;
            };

            var createPanels = function createPanels() {
                /*
                 const starPanel = createSprite("stars_panel", this._uIntHolder);
                 starPanel.x = -p3.View.width * 0.5 + starPanel.width * 0.5 + 15;
                 starPanel.y = 15;
                 this._starsText = new PIXI.Text("" + this._starsCollected, {
                 fontFamily: "arial",
                 fontSize: "33px",
                 fill: "white"
                 });
                 this._starsText.anchor.set(0.5);
                 this._starsText.x = starPanel.width * 0.5 - 40;
                 this._starsText.y = starPanel.height * 0.5 - 2;
                 starPanel.addChild(this._starsText);
                 const starFill = createSprite("stars_panel_fill");
                 this._starPanel = starPanel;
                   let star = createSprite("stars_panel_icon", starPanel);
                 star.anchor.set(0.5);
                 star.x = -starPanel.width * 0.5 + star.width * 0.5 + 8;
                 star.y = starPanel.height * 0.5;
                 this._starIcon = star;
                   //add particles
                 const config = Common.assets.getJSON("particles_boostmeter");
                 let partEmitter = new PIXI.particles.Emitter(starPanel, [Common.assets.getTexture("part_star")], config);
                 partEmitter.updateSpawnPos(star.x, star.y);
                 partEmitter.emit = false;
                 this._starParticles = partEmitter;
                 //emitter.updateSpawnPos(banner.x, banner.y);
                 this._particleEmitters.push(partEmitter);
                   var myMask = new PIXI.Graphics();
                 myMask.beginFill();
                 myMask.drawRect(0, 0, 150, starFill.height);
                 myMask.endFill();
                 myMask.x = -225;
                     starPanel.addChild(myMask, starFill);
                 //   this.addChild(myMask, starFill);
                   starFill.mask = myMask;
                   this._maskStartX = myMask.x;
                 this._fillMask = myMask;
                 //mask 150 px
                 */

                var starBtnBk = createSprite("btn_boost_bg", _this12._uIntHolder);
                //    const starBtnFill = Common.generateEllipse(50, 50, 0xf0f889f);
                //  starBtnFill.anchor.set(0.5, 0);
                // starBtnBk.addChild(starBtnFill);

                starBtnBk.x = -p3.View.width * 0.5 + starBtnBk.width * 0.5 + 25;
                starBtnBk.y = p3.View.height - starBtnBk.height - 25;
                starBtnBk.anchor.set(0.5);

                starBtnBk.visible = false;

                var emitter = new PIXI.particles.Emitter(_this12._uIntHolder, [_Common2.default.assets.getTexture("part_star")], _this12._starBurstConfig);
                emitter.updateOwnerPos(starBtnBk.x, starBtnBk.y);
                emitter.emit = false;
                _this12._starBtnEmitter = emitter;
                _this12._particleEmitters.push(emitter);

                //  if (this._graphics) this._gameHolder.removeChild(this._graphics);

                var rad = 52;
                _this12._graphics = new PIXI.Graphics();
                _this12._graphics.pivot.set(0.5);

                _this12._graphics.x = -rad * 0.5 - 5;
                _this12._graphics.y = -starBtnBk.height * 0.5 + 25;
                _this12._graphicsY = _this12._graphics.y;

                // this._graphics.clear();
                _this12._graphics.lineStyle(21, 0xffe011);
                _this12._currentFill = -Math.PI * 0.5;
                ///  this._currentFill += (2 * Math.PI);
                _this12._graphics.arc(32, 57, rad, -Math.PI * 0.5, _this12._currentFill);
                //  .//  this._gameHolder.addChild(this._graphics);
                starBtnBk.addChild(_this12._graphics);
                var starBtnFront = createSprite("btn_boost_off", starBtnBk);
                starBtnFront.anchor.set(0.5, 0.5);

                _this12._starBtnFront = starBtnFront;
                _this12._starBtnBack = starBtnBk;

                _this12._starBtnBack.interactive = true;
                _this12._starBtnBack.mousedown = _this12._starBtnBack.touchstart = _this12.inputDown.bind(_this12);

                var config = _Common2.default.assets.getJSON("particles_boostmeter");
                var partEmitter = new PIXI.particles.Emitter(starBtnBk, [_Common2.default.assets.getTexture("part_star")], config);
                //  partEmitter.updateSpawnPos(0, starBtnBk.height * 0.5);
                partEmitter.emit = false;
                _this12._starParticles = partEmitter;
                //emitter.updateSpawnPos(banner.x, banner.y);
                _this12._particleEmitters.push(partEmitter);

                var count = 0;
                var test = function test() {
                    count++;
                    console.log("count : " + count);
                    _this12._starBtnBack.removeChild(_this12._graphics);
                    _this12._graphics.clear();
                    _this12._graphics.destroy();
                    _this12._graphics = new PIXI.Graphics();
                    _this12._graphics.pivot.set(0.5);
                    _this12._graphics.x = -rad * 0.5 - 4.5;
                    // this._graphics.y = rad * 0.5 - 1;
                    _this12._graphics.lineStyle(21, 0xffe011);
                    _this12._currentFill += 2 * Math.PI / 20;
                    _this12._graphics.arc(32, 57, rad, -Math.PI * 0.5, _this12._currentFill);
                    _this12._starBtnBack.addChild(_this12._graphics, starBtnFront);
                    //   delay(test, 1, this);
                };
                //test();


                var distPanel = createSprite("distance_panel", _this12._uIntHolder);
                distPanel.x = -p3.View.width * 0.5 + distPanel.width * 0.5 + 15;
                distPanel.y = 15;
                _this12._distanceText = new PIXI.Text("" + _this12._starsCollected, {
                    fontFamily: "arial",
                    fontSize: "33px",
                    fill: "white"
                });
                _this12._distanceText.anchor.set(0.5);
                _this12._distanceText.x = distPanel.width * 0.5 - 55;
                _this12._distanceText.y = distPanel.height * 0.5 - 2;
                distPanel.addChild(_this12._distanceText);

                _this12._distPanel = distPanel;
            };

            createPanels();
            createPauseScreen();

            this.pauseBtn = _Common2.default.createButton(p3.View.width * 0.5 - 75, 65, "small", this.pauseClick, this, this._uIntHolder, "icon_pause");
        }
    }, {
        key: "pauseClick",
        value: function pauseClick() {
            var _this13 = this;

            this.pauseBtn.interactive = !this.pauseBtn.interactive;

            this._distPanel.visible = !this._distPanel.visible;
            //this._starPanel.visible = !this._starPanel.visible;
            _Common2.default.paused = !_Common2.default.paused;

            if (this._launched) this._starBtnBack.visible = !this._starBtnBack.visible;

            if (_Common2.default.paused) {
                this._alien.state.timeScale = 0;
                this.pauseBtn.visible = false;
                this.pauseBtn.renderable = false;
                this.pauseScreen.visible = true;
                this.starterHappo.autoUpdate = false;
                this._running = false;
                this._happo.autoUpdate = false;
                TweenMax.pauseAll();
                this._mapHolder.filters = this._blurFilter;
                this._distanceText.visible = false;
                //     this._starsText.visible = false;
                this._sky.interactive = false;
            } else {
                this._alien.state.timeScale = 1;
                this.pauseBtn.visible = true;
                this.pauseBtn.renderable = true;
                this.pauseScreen.visible = false;
                this.starterHappo.autoUpdate = true;
                this._running = true;
                this._happo.autoUpdate = true;
                TweenMax.resumeAll();
                this._mapHolder.filters = null;
                this._distanceText.visible = true;
                //    this._starsText.visible = true;
                this._sky.interactive = true;
                this.justUnpaused = true;
                delay(function () {
                    _this13.justUnpaused = false;
                }, 1.5, this);
            }
        }
    }, {
        key: "gameOver",
        value: function gameOver() {
            var _this14 = this;

            //console.log("game over");
            TweenMax.killAll();
            _Common2.default.audio.stopMusic("music_ready_loop_012");
            _Common2.default.audio.stopSound("sfx_ambient_desert_loop_00");
            _Common2.default.audio.playSound("music_results_short_00");
            _Common2.default.flyDist = this._totalDist;
            // this.gameFinished = true;

            this._starParticles.emit = false;
            //this._happo.filters = null;
            this._boostReadyEmitter.emit = false;
            for (var i = 0; i < 3; i++) {
                if (this._totalDist > _Common2.default.highScores[i]) {
                    _Common2.default.highScores.splice(i, 0, this._totalDist);
                    _Common2.default.highScores.pop();
                    _Common2.default.sort(_Common2.default.highScores, true);
                    _Common2.default.saveGame();
                    break;
                }
            }
            delay(function () {
                //console.log("ending");
                _this14.end();
            }, 2, this);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            TweenMax.killAll();

            //loop through display objects and destroy
            for (var i = 0; i < disp.length; i++) {
                disp[i].destroy();
                disp[i] = null;
                delete disp[i];
            }
            disp.length = 0;

            for (var _i37 = 0; _i37 < this._containers.length; _i37++) {
                this._containers[_i37].destroy();
                this._containers[_i37] = null;
                delete this._containers[_i37];
            }
            this._containers.length = 0;

            for (var _i38 = 0; _i38 < this._particleEmitters.length; _i38++) {
                this._particleEmitters[_i38].destroy();
                this._particleEmitters[_i38] = null;
                delete this._particleEmitters[_i38];
            }
            this._particleEmitters.length = 0;
            _Common2.default.renderer.plugins.sprite.sprites.length = 0;

            _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = p3.View.width * 0.5;
            var bgTiles = this._sky;
            bgTiles.width = p3.View.width * 2;
            bgTiles.height = p3.View.height * 2.5;

            //  const starPanel = this._starPanel;
            //  starPanel.x = -p3.View.width * 0.5 + starPanel.width * 0.5 + 15;

            var distPanel = this._distPanel;
            distPanel.x = -p3.View.width * 0.5 + distPanel.width * 0.5 + 15;

            this.pauseBtn.x = p3.View.width * 0.5 - 75;

            //   const leftPanel = this.leftPanel;
            //  leftPanel.y = this.leftBtn.y + this.leftBtn.height * 0.5 + 15;
            //   leftPanel.scale.x = 1;
        }
    }]);

    return GameScene;
}(p3.Scene);

exports.default = GameScene;


function createSprite(texture, holder) {
    var sprite = void 0;
    if (typeof texture === "string") sprite = new PIXI.Sprite(_Common2.default.assets.getTexture(texture));else if (texture instanceof PIXI.Texture) sprite = new PIXI.Sprite(texture);else {
        //console.warn("texture neither a string nor a PIXI.Texture, falling back to empty texture");
        sprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
    }
    sprite.anchor = { x: 0.5, y: 0 };
    if (holder) holder.addChild(sprite);
    _Common2.default.displayObjs.push(sprite);
    disp.push(sprite);

    return sprite;
}

function getTex(name) {
    return _Common2.default.assets.getTexture(name);
}

},{"../assets/data/config":1,"./Common":6}],8:[function(require,module,exports){
/**
 *  PreloaderScene
 *
 *  Created by Legman on 7/10/2015.
 *
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @constructor
 * @extends {p3.Scene}
 */
function PreloaderScene() {

    /**
     * @type {number}
     */
    this.loaded = 0.0;

    /**
     * @type {PIXI.Sprite}
     */
    this._bar = null;

    /**
     * @type {PIXI.Sprite}
     */
    this._barBack = null;

    /**
     * @type {PIXI.Sprite}
     */
    this._bg = null;

    /**
     * @type {PIXI.BitmapText}
     */
    this._text = null;

    /**
     * @type {PIXI.BitmapText}
     */
    this._percent = null;

    /**
     * @type {string}
     */
    this._cheatyHax = "%";

    p3.Scene.call(this);
}

exports.default = PreloaderScene;

PreloaderScene.prototype = Object.create(p3.Scene.prototype);
PreloaderScene.prototype.constructor = PreloaderScene;

PreloaderScene.prototype.init = function () {

    //console.log(Common.assets);

    this._bg = new PIXI.Sprite(_Common2.default.assets.getTexture("preloader_bg"));
    //this._barBack = new PIXI.Sprite(Common.assets.getTexture("preloader_bar"));


    //  this._text.y = p3.View.height * 0.5 - 75;
    //  this._text.x = Common.STAGE_WIDTH * 0.5 - 25;
    // this._percent.x = this._text.x + 65;

    // this._percent.y = this._text.y;

    // this._percent.visible = false;

    this.addChild(this._bg);

    var g = new PIXI.Graphics();
    g.beginFill(_Common2.default.language == 'es' ? 0xf1dc27 : 0x872F87);
    g.drawRect(0, 0, _Common2.default.STAGE_WIDTH, _Common2.default.STAGE_HEIGHT);
    g.endFill();
    this.addChild(g);

    var holder = new PIXI.Container();
    holder.x = _Common2.default.STAGE_WIDTH * 0.5;
    holder.y = Math.floor(p3.View.height * 0.5) + 50;
    this.addChild(holder);

    var logoFrames = [];
    for (var i = 1; i < 10; i++) {
        logoFrames.push(_Common2.default.assets.getTexture('loader_animation000' + i));
    }
    logoFrames.push(_Common2.default.assets.getTexture('loader_animation0010'));

    this._logoAnimation = new PIXI.extras.AnimatedSprite(logoFrames);
    this._logoAnimation.animationSpeed = 0.4;
    this._logoAnimation.gotoAndStop(0);
    this._logoAnimation.stop();
    this._logoAnimation.loop = false;
    this._logoAnimation.anchor.x = 0.5;
    this._logoAnimation.anchor.y = 1.0;
    this._logoAnimation.x += 50;
    this._logoAnimation.y -= 20;
    holder.addChild(this._logoAnimation);

    this._logoAnimation.play();

    this._bar = new PIXI.Sprite(_Common2.default.assets.getTexture('preloader_bar'));
    this._bar.anchor.y = 0.5;
    this._bar.x -= this._bar.width * 0.5;

    if (_Common2.default.language == 'es') {
        var bar = new PIXI.Graphics();
        bar.beginFill(0x00d3de);
        bar.x = this._bar.x;
        bar.y = this._bar.y;
        bar.drawRect(0, -this._bar.height / 2, this._bar.width, this._bar.height);
        this._bar = bar;
    }

    this._bar.scale.x = 0;
    holder.addChild(this._bar);

    this._barOverlay = new PIXI.Sprite(_Common2.default.assets.getTexture(_Common2.default.language == 'es' ? 'preloader_overlay_es' : 'preloader_overlay'));
    this._barOverlay.anchor.y = 0.5;
    this._barOverlay.anchor.x = 0.5;
    holder.addChild(this._barOverlay);

    this._text = new PIXI.Text("0%", { fontFamily: 'Arial', fontSize: '38px', 'fill': _Common2.default.language == 'es' ? '#00d3de' : '#FFFFFF' });
    this._text.anchor.x = 0.5;
    this._text.position.y += 50;

    holder.addChild(this._text);

    if (_Common2.default.language == 'es') {
        this._logoAnimation.visible = false;
        var esLogo = new PIXI.Sprite(_Common2.default.assets.getTexture('preloader_es'));
        esLogo.anchor = new PIXI.Point(0.5, 1);
        esLogo.x = 0;
        esLogo.y = this._logoAnimation.y - 40;
        holder.addChild(esLogo);
    }
};

PreloaderScene.prototype.destroy = function () {
    p3.Scene.prototype.destroy.call(this);
};

PreloaderScene.prototype.appear = function () {
    this.animateIn();
};

PreloaderScene.prototype.show = function () {};

PreloaderScene.prototype.animateIn = function (callback, scope) {};

PreloaderScene.prototype.animateOut = function (callback, scope) {};

PreloaderScene.prototype.resize = function () {
    this.x = (p3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;
};

PreloaderScene.prototype.update = function () {

    var offset = 0;

    if (_Common2.default.language == 'es') offset = 5;

    this._bar.width = this._barOverlay.width * this.loaded - offset;
    if (this._bar.width > this._barOverlay.width - offset) this._bar.width = this._barOverlay.width - offset;
    this._text.text = "" + Math.round(this.loaded * 100) + "%";
    if (Math.round(this.loaded * 100) > 100) this._text.text = "100%";
};

},{"./Common":6}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var disp = [];

var SplashScene = function (_p3$Scene) {
    _inherits(SplashScene, _p3$Scene);

    function SplashScene() {
        _classCallCheck(this, SplashScene);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (SplashScene.__proto__ || Object.getPrototypeOf(SplashScene)).call(this));

        _this._bg = null;

        /**
         *
         * @type {PIXI.Container}
         * @private
         */
        _this._primaryHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._uiHolder = new PIXI.Container();

        /**
         * @type {Array}
         * @private
         */
        _this._particles = [];

        /**
         * @type {Array}
         * @private
         */
        _this._happos = [];

        /**
         * @type {Array}
         * @private
         */
        _this._containers = [];
        return _this;
    }

    _createClass(SplashScene, [{
        key: "init",
        value: function init() {

            //load saved data if it exists
            _Common2.default.loadGame();

            //add to containers
            this.addChild(this._primaryHolder, this._uiHolder);
            this._containers = [this._primaryHolder, this._uiHolder];

            //create bg
            this._bg = createSprite("bg", this._primaryHolder);

            //init display objects
            this.initDisp();

            //init ui elements
            this.initUI();

            //--play sounds--//

            _Common2.default.audio.playSound("music_results_long_00");
            _Common2.default.audio.playSound("sfx_ambient_desert_loop_00", true);

            this.start();
        }
    }, {
        key: "start",
        value: function start() {
            this._running = true;
            this.jumpHappo();
        }
    }, {
        key: "end",
        value: function end() {
            this._running = false;
            this.signals.next.dispatch(this);
        }
    }, {
        key: "initDisp",
        value: function initDisp() {

            var happo3 = this.createHappo("happo_3", this._primaryHolder);
            ///  let happo2 = createSprite("happo_2", this._primaryHolder);

            //   let emitter =


            var banner = createSprite("banner", this._primaryHolder);
            banner.x = 168;
            banner.y = 160;

            var happo1 = this.createHappo("happo_1", this._primaryHolder);
            var happo4 = this.createHappo("happo_4", this._primaryHolder);
            var happo5 = this.createHappo("happo_5", this._primaryHolder);
            happo5.x = 459;
            happo5.y = 111;

            var shadow = createSprite("shadow", this._primaryHolder);
            var happoStunt = this.createHappo("stunt_endgame", this._primaryHolder);
            happoStunt.x = 359;
            happoStunt.y = p3.View.height - 35;
            shadow.anchor.set(0.5, 1);
            shadow.position.set(happoStunt.x + 15, happoStunt.y + 15);

            happo1.x = -376;
            happo1.y = p3.View.height - 15;

            happo4.x = 575;
            happo4.y = p3.View.height - 25;

            happo3.x = -150;
            happo3.y = p3.View.height - 55;

            var obj = happo3;
            obj.shadow.position.set(obj.x, obj.y + 5);
            obj = happo1;
            obj.shadow.position.set(obj.x, obj.y + 5);
            obj = happo4;
            obj.shadow.position.set(obj.x, obj.y + 5);
            //  this.makeDraggable(happo4);
            /*
             let bannerTxtView = new PIXI.extras.BitmapText("Well Done!\nYou've flown\n" + Common.flyDist + " M.\nBest score " + Common.highScores[0] + " M.", {
             font: "55px Ziclets",
             align: "center",
             tint: 0x2958a1
             });
             /*
             /*
             new PIXI.Text("Well Done!\nYou've flown\n" + Common.flyDist + " M.\nBest score " + Common.highScores[0] + " M.", {
             fontFamily: "arial",
             fontSize: "50px",
             align: "center"
             });
             */

            var extraPad = _Common2.default.flyDist.toString().length >= 5;

            var bannerTxtView = new PIXI.extras.BitmapText(_Common2.default.copy.well_done[_Common2.default.language], {
                font: "55px Ziclets",
                align: "center",
                tint: 0x2958a1
            });
            var bannerTxtView2 = new PIXI.extras.BitmapText(_Common2.default.copy.distance[_Common2.default.language], {
                font: "35px VAGRounded-Light",
                align: "center",
                tint: 0x2958a1
            });
            var bannerTxtView3 = new PIXI.extras.BitmapText("" + _Common2.default.flyDist + " M.", {
                font: "75px Ziclets",
                align: "center",
                tint: 0xd21402
            });
            var bannerTxtView4 = new PIXI.extras.BitmapText(_Common2.default.copy.best_score[_Common2.default.language] + " " + _Common2.default.highScores[0] + " M.", {
                font: "35px VAGRounded-Light",
                align: "center",
                tint: 0x2958a1
            });

            bannerTxtView.anchor.set(0.5);
            bannerTxtView2.anchor = bannerTxtView3.anchor = bannerTxtView4.anchor = bannerTxtView.anchor;
            banner.addChild(bannerTxtView, bannerTxtView2, bannerTxtView3, bannerTxtView4);

            bannerTxtView.x = bannerTxtView2.x = bannerTxtView3.x = bannerTxtView4.x = -150;
            bannerTxtView.y = 75;
            bannerTxtView2.y = bannerTxtView.y + 75;
            bannerTxtView3.y = bannerTxtView2.y + 35;
            bannerTxtView4.y = bannerTxtView3.y + 85;

            var star = createSprite("star", banner);
            var star2 = createSprite("star", banner);
            star.anchor.set(0.5);
            star2.anchor.set(0.5);
            star.y = star2.y = 215;
            star.x = -300;

            star.x -= 25;
            star2.x += 25;

            if (extraPad) {
                star.x -= 25;
                star2.x += 25;
            }

            //--make particles--//
            var config = _Common2.default.assets.getJSON("particles_gameover");
            var emitter = new PIXI.particles.Emitter(this._uiHolder, [_Common2.default.assets.getTexture("part_1"), _Common2.default.assets.getTexture("part_2"), _Common2.default.assets.getTexture("part_3"), _Common2.default.assets.getTexture("part_4"), _Common2.default.assets.getTexture("part_5"), _Common2.default.assets.getTexture("part_6"), _Common2.default.assets.getTexture("part_7")], config);
            emitter.updateSpawnPos(25, 200);
            this._particles.push(emitter);
            emitter.emit = true;
        }
    }, {
        key: "initUI",
        value: function initUI() {
            var _this2 = this;

            var playClick = function playClick() {
                _this2.signals.next.dispatch(_this2);
            };
            var btnReplay = _Common2.default.createButton(0, p3.View.height * 0.5 + 225, "big", playClick, this, this._uiHolder, "icon_replay");

            var muteClick = function muteClick() {
                _Common2.default.isMute = !_Common2.default.isMute;
                _Common2.default.audio.mute(_Common2.default.isMute);
                if (!_Common2.default.isMute) _this2.soundBtn.icon.texture = _Common2.default.assets.getTexture("icon_sound_on");else _this2.soundBtn.icon.texture = _Common2.default.assets.getTexture("icon_sound_off");
            };
            this.soundBtn = _Common2.default.createButton(p3.View.width * 0.5 - 75, 65, "small", muteClick, this, this._uiHolder, "icon_sound_off");
            if (!_Common2.default.isMute) this.soundBtn.icon.texture = _Common2.default.assets.getTexture("icon_sound_on");

            var homeClick = function homeClick() {
                _this2.signals.home.dispatch(_this2);
            };
            this.homeBtn = _Common2.default.createButton(-p3.View.width * 0.5 + 75, 65, "small", homeClick, this, this._uiHolder, "icon_home");
        }
    }, {
        key: "jumpHappo",
        value: function jumpHappo() {
            var _this3 = this;

            var delayTime = 4;
            var jump = function jump() {
                var rand = Math.floor(Math.random() * _this3._happos.length);
                var happo = _this3._happos[rand];
                happo.tween.pause();
                TweenMax.to(happo, 0.25, { y: happo.y - 25, yoyo: true, repeat: 1 });
                TweenMax.to(happo.scale, 0.25, {
                    x: happo.scale.x - 0.05,
                    y: happo.scale.y + 0.05,
                    yoyo: true,
                    repeat: 1,
                    onComplete: function onComplete() {
                        happo.tween.resume();
                    }
                });
                delay(jump, delayTime, _this3);
            };
            delay(jump, delayTime, this);
        }
    }, {
        key: "createHappo",
        value: function createHappo(name, holder) {
            var shadow = createSprite("shadow", holder);
            shadow.anchor.set(0.5, 1);
            var obj = createSprite(name, holder);
            obj.anchor.y = 1;
            obj.scale.set(0.8);
            obj.tween = TweenMax.to(obj.scale, 1, {
                x: obj.scale.x + 0.02,
                y: obj.scale.y - 0.02,
                ease: Power0.easeNone,
                yoyo: true,
                repeat: -1,
                repeatDelay: 0.15 + Math.random * 0.2,
                delay: Math.random()
            });
            if (name !== "happo_5") this._happos.push(obj);
            obj.shadow = shadow;
            return obj;
        }
    }, {
        key: "destroy",
        value: function destroy() {
            //Common.animator.removeAll();
            _Common2.default.audio.stopSound("sfx_ambient_desert_loop_00");
            TweenMax.killAll();

            for (var i = 0; i < disp.length; i++) {
                disp[i].destroy();
                disp[i] = null;
                delete disp[i];
            }
            disp.length = 0;

            for (var _i = 0; _i < this._containers.length; _i++) {
                this._containers[_i].destroy();
                this._containers[_i] = null;
                delete this._containers[_i];
            }
            this._containers.length = 0;

            for (var _i2 = 0; _i2 < this._particles.length; _i2++) {
                this._particles[_i2].destroy();
                this._particles[_i2] = null;
                delete this._particles[_i2];
            }
            this._particles.length = 0;
            _Common2.default.renderer.plugins.sprite.sprites.length = 0;

            _get(SplashScene.prototype.__proto__ || Object.getPrototypeOf(SplashScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = p3.View.width * 0.5;
            this.homeBtn.x = -p3.View.width * 0.5 + 75;
            this.soundBtn.x = p3.View.width * 0.5 - 75;
        }
    }, {
        key: "update",
        value: function update() {
            if (this.dragging) {
                var pos = this.dragging.inputData.getLocalPosition(this);
                this.dragging.position.set(pos.x, pos.y);
            }

            for (var i in this._particles) {
                this._particles[i].update(deltaTime);
            }
        }
    }]);

    return SplashScene;
}(p3.Scene);

exports.default = SplashScene;


function createSprite(texture, holder) {
    var sprite = void 0;
    if (typeof texture === "string") sprite = new PIXI.Sprite(_Common2.default.assets.getTexture(texture));else if (texture instanceof PIXI.Texture) sprite = new PIXI.Sprite(texture);
    sprite.anchor = { x: 0.5, y: 0 };
    if (holder) holder.addChild(sprite);
    return sprite;
}

},{"./Common":6}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var disp = [];

var SplashScene = function (_p3$Scene) {
    _inherits(SplashScene, _p3$Scene);

    function SplashScene() {
        _classCallCheck(this, SplashScene);

        /**
         * @type {number}
         */
        var _this = _possibleConstructorReturn(this, (SplashScene.__proto__ || Object.getPrototypeOf(SplashScene)).call(this));

        _this.tileSize = 1020;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._bg = null;

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._primaryHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._uiHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._bgHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._midHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        _this._fgHolder = new PIXI.Container();

        /**
         * @type {null}
         */
        _this.dragging = null;

        /**
         * @type {Array}
         * @private
         */
        _this._happos = [];

        /**
         * @type {Array}
         * @private
         */
        _this._containers = [];

        /**
         * @type {null}
         */
        _this.sky = null;

        /**
         * @type {null}
         */
        _this.soundBtn = null;

        /**
         * @type {null}
         */
        _this.logo = null;
        return _this;
    }

    _createClass(SplashScene, [{
        key: "init",
        value: function init() {
            var _this2 = this;

            /*
             let test = createSprite("happo_1", this._uiHolder);
               let lerp = (obj, time, target) => {
             time *= 1000; //to ms
             let startTime = Date.now();
             var lerper = () => {
             const elapsed = Date.now() - startTime;
             //console.log(elapsed + " : " + time);
             if (elapsed >= time) return;
             const perc = (Common.toPercent(time, elapsed)) / 100;
             const updated = Common.lerp(obj, target, perc / 100);
             obj.x = updated.x;
             obj.y = updated.y;
             //console.log(obj.x + ", " + obj.y);
             setTimeout(lerper, 16.6);
             };
             lerper();
             };
             let targ = {x: 250, y: 250};
               delay(()=> {
             lerp(test, 10, targ);
             }, 3, this);
             */
            //load saved data if it exists
            _Common2.default.loadGame();

            //add to containers
            this.addChild(this._bgHolder, this._midHolder, this._fgHolder, this._primaryHolder, this._uiHolder);
            this._containers = [this._bgHolder, this._midHolder, this._fgHolder, this._primaryHolder, this._uiHolder];

            //create bg
            // this._bg = createSprite("bg", this._primaryHolder);

            //init ui elements
            this.initUI();

            //init display objects
            this.initDisp();

            _Common2.default.audio.playMusic("music_mainmenu_loop_00");

            ///TweenMax.from(this, 8, {x: p3.View.width});
            this.addDeco();

            this.start();

            //animate in
            var tweenTime = 1.5;
            TweenMax.from(this.mountainTiles.tilePosition, tweenTime, { x: 200, ease: Power1.easeOut });
            for (var i in this.clouds) {
                TweenMax.from(this.clouds[i], tweenTime, { x: this.clouds[i].x + 200, ease: Power1.easeOut });
            }
            TweenMax.from(this.midTiles.tilePosition, tweenTime, { x: 800, ease: Power1.easeOut });

            TweenMax.from(this.floorTiles.tilePosition, tweenTime, { x: 1200, ease: Power1.easeOut });
            for (var _i in this.happos) {
                TweenMax.from(this.happos[_i], tweenTime, { x: this.happos[_i].x + 1200, ease: Power1.easeOut });
                if (this.happos[_i].shadow) {
                    this.happos[_i].shadow.position.set(this.happos[_i].x, this.happos[_i].y + 5);
                    TweenMax.from(this.happos[_i].shadow, tweenTime, { x: this.happos[_i].x + 1200, ease: Power1.easeOut });
                }
            }
            TweenMax.from(this.banner, tweenTime, {
                x: this.banner.x + 1200, ease: Power1.easeOut, onComplete: function onComplete() {
                    _this2.finishAnim();
                }
            });
            //TweenMax.from(this.banner, 3, {x: 1200, ease: Power1.easeOut});
        }
    }, {
        key: "finishAnim",
        value: function finishAnim() {
            TweenMax.to(this.playBtn.scale, 0.5, { x: 1, y: 1, ease: Bounce.easeOut });
            TweenMax.to(this.soundBtn.scale, 0.5, { x: 1, y: 1, ease: Bounce.easeOut });
            TweenMax.to(this.logo.scale, 0.5, { x: 0.9, y: 0.9, ease: Bounce.easeOut });
        }
    }, {
        key: "jumpHappo",
        value: function jumpHappo() {
            var _this3 = this;

            var delayTime = 4;
            var jump = function jump() {
                var rand = Math.floor(Math.random() * _this3._happos.length);
                var happo = _this3._happos[rand];
                happo.tween.pause();
                TweenMax.to(happo, 0.25, { y: happo.y - 25, yoyo: true, repeat: 1 });
                TweenMax.to(happo.scale, 0.25, {
                    x: happo.scale.x - 0.05,
                    y: happo.scale.y + 0.05,
                    yoyo: true,
                    repeat: 1,
                    onComplete: function onComplete() {
                        happo.tween.resume();
                    }
                });
            };
            delay(jump, delayTime, this);
        }
    }, {
        key: "addDeco",
        value: function addDeco() {

            var bgTiles = createSprite("sky", this._bgHolder);
            //bgTiles.x = -p3.View.width * 0.5;
            bgTiles.width = p3.View.width + 200;
            bgTiles.height = p3.View.height + 210;

            var floor = new PIXI.extras.TilingSprite(_Common2.default.assets.getTexture("ground"), this.tileSize * 3, 550 / 2);
            floor.position.x = -2040;
            floor.position.y = p3.View.height * 0.5 + 50;
            floor.scale.y = 1.25;

            var mountains = new PIXI.extras.TilingSprite(_Common2.default.assets.getTexture("mountains_bg"), this.tileSize * 3, 466 / 2);
            mountains.position.x = -2040;
            mountains.position.y = p3.View.height * 0.5 - 250;
            mountains.scale.set(2);

            var mid = new PIXI.extras.TilingSprite(_Common2.default.assets.getTexture("mid_ground"), this.tileSize * 3, 500 / 2);
            mid.position.x = -2040;
            mid.position.y = p3.View.height * 0.5;

            disp.push(floor, mountains, mid);

            this.floorTiles = floor;
            this.mountainTiles = mountains;
            this.midTiles = mid;
            this.sky = bgTiles;

            this._fgHolder.addChild(floor);
            this._bgHolder.addChild(mountains);
            this._midHolder.addChild(mid);

            //let tree = createSprite("tree_midground", this._midBackHolder);

            //--add in clouds--//
            this.clouds = [];
            for (var i = 0; i < 5; i++) {
                var obj = createSprite("cloud_b_" + Math.ceil(Math.random() * 3), this._bgHolder);
                obj.x = i * 1000 - Math.random() * 2000;
                obj.y = p3.View.height * 0.5 - 300 - Math.random() * 150;
                //obj.scale.set((Math.random() * 0.25) + 0.75);
                this.clouds.push(obj);
            }
        }
    }, {
        key: "start",
        value: function start() {
            this._running = true;
            //--start happos randomly jumping--//
            this.jumpHappo();
            //  Common.smoothie.update = this.update.bind(this);
        }
    }, {
        key: "update",
        value: function update() {
            if (this.dragging) {
                var pos = this.dragging.inputData.getLocalPosition(this);
                this.dragging.position.set(pos.x, pos.y);
            }
        }
    }, {
        key: "end",
        value: function end() {
            this._running = false;
            this.signals.next.dispatch(this);
        }
    }, {
        key: "initUI",
        value: function initUI() {
            var _this4 = this;

            var pressed = false; //probably don't need to, but client reported bug caused by spamming this button (the bug actually is because they manage to press input down on game scene before happpo is in cannon)
            var playClick = function playClick() {
                if (pressed) return;
                pressed = true;
                _this4.signals.next.dispatch(_this4);
            };
            var btnPlay = _Common2.default.createButton(0, p3.View.height * 0.5 + 225, "big", playClick, this, this._uiHolder, "icon_play");
            btnPlay.scale.set(0);
            this.playBtn = btnPlay;

            var muteClick = function muteClick() {
                _Common2.default.isMute = !_Common2.default.isMute;
                _Common2.default.audio.mute(_Common2.default.isMute);
                if (!_Common2.default.isMute) _this4.soundBtn.icon.texture = _Common2.default.assets.getTexture("icon_sound_on");else _this4.soundBtn.icon.texture = _Common2.default.assets.getTexture("icon_sound_off");
            };
            this.soundBtn = _Common2.default.createButton(p3.View.width * 0.5 - 75, 65, "small", muteClick, this, this._uiHolder, "icon_sound_off");
            if (!_Common2.default.isMute) this.soundBtn.icon.texture = _Common2.default.assets.getTexture("icon_sound_on");
            this.soundBtn.scale.set(0);
            /*
             var homeClick = () => {
             open(Common.homeURL);
             };
             const btnHome = Common.createButton(-p3.View.width * 0.5 + 75, 65, "small", homeClick, this, this._uiHolder, "icon_home");
             */
        }
    }, {
        key: "initDisp",
        value: function initDisp() {

            var tree = createSprite("tree_transparent", this._primaryHolder);
            tree.x = -p3.View.width * 0.5 + 125;
            tree.y = -75;

            var pond = createSprite("water_hole_fg", this._primaryHolder);
            pond.anchor.set(0.5, 1);
            pond.y = p3.View.height;
            pond.x = 125;

            var banner = createSprite("banner", this._primaryHolder);
            banner.x = banner.y = 105;
            var txtView = void 0;
            if (_Common2.default.language === "ar") {
                txtView = p3.simpleText(_Common2.default.copy.title[_Common2.default.language], "arial", 120, null, 0xd21402);
            } else if (_Common2.default.language === "ru") {
                txtView = p3.simpleText(_Common2.default.copy.title[_Common2.default.language], "arial", 65, null, 0xd21402);
            } else {
                txtView = new PIXI.extras.BitmapText(_Common2.default.copy.title[_Common2.default.language], {
                    font: "95px Ziclets",
                    align: "center",
                    tint: 0xd21402
                });
                txtView.maxWidth = 250;
                if (_Common2.default.language === "hu") {
                    txtView.maxWidth = 600;
                }
                txtView.anchor.set(0.5);
            }

            banner.addChild(txtView);
            txtView.x = -140;
            txtView.y = 135;
            banner.scale.set(0.8);
            banner.y = 175;
            if (_Common2.default.language === "hu") {
                txtView.y += 10;
            }

            if (_Common2.default.language !== "en") {
                txtView.scale.set(0.65);
            }

            var logo = createSprite("happos_logo", this._primaryHolder);
            logo.y = 15;
            logo.scale.set(0);
            this.logo = logo;
            this.banner = banner;

            var happo2 = this.createHappo("happo_2", this._primaryHolder);
            happo2.x = 262;
            happo2.y = p3.View.height - 75;

            var happo1 = this.createHappo("happo_1", this._primaryHolder);
            happo1.x = -498;
            happo1.y = p3.View.height - 100;

            var stunt = createSprite("stunt_splash", this._primaryHolder);
            stunt.y = -15;
            stunt.x = 75;

            this.happos = [happo1, happo2, stunt, pond, tree];

            var bLogo = createSprite(_Common2.default.language == 'es' ? "preloader_es" : "boomerang_logo", this._primaryHolder);
            bLogo.x = p3.View.width * 0.5 - bLogo.width * 0.5 - 15;
            bLogo.y = p3.View.height - bLogo.height - 15;

            if (_Common2.default.language == 'es') {
                bLogo.scale = new PIXI.Point(0.4, 0.4);
                bLogo.y += 170;
            }

            this.bLogo = bLogo;
        }
    }, {
        key: "destroy",
        value: function destroy() {
            TweenMax.killAll();

            //loop through display objects and destroy
            for (var i = 0; i < disp.length; i++) {
                disp[i].destroy();
                disp[i] = null;
                delete disp[i];
            }
            disp.length = 0;

            for (var _i2 = 0; _i2 < this._containers.length; _i2++) {
                this._containers[_i2].destroy();
                this._containers[_i2] = null;
                delete this._containers[_i2];
            }
            this._containers.length = 0;

            _Common2.default.audio.stopMusic("music_mainmenu_loop_00");

            _get(SplashScene.prototype.__proto__ || Object.getPrototypeOf(SplashScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = p3.View.width * 0.5;

            this.sky.width = p3.View.width + 200;
            this.sky.height = p3.View.height + 210;

            this.soundBtn.x = p3.View.width * 0.5 - 75;

            this.bLogo.x = p3.View.width * 0.5 - this.bLogo.width * 0.5 - 15;
        }
    }, {
        key: "createHappo",
        value: function createHappo(name, holder) {
            var shadow = createSprite("shadow", holder);
            var obj = createSprite(name, holder);
            obj.anchor.y = 1;
            //obj.scale.set(0.8);
            obj.tween = TweenMax.to(obj.scale, 1, {
                x: obj.scale.x + 0.02,
                y: obj.scale.y - 0.02,
                ease: Power0.easeNone,
                yoyo: true,
                repeat: -1,
                repeatDelay: 0.15 + Math.random * 0.2,
                delay: Math.random()
            });
            this._happos.push(obj);
            //obj.y += 15;
            shadow.anchor.set(0.5, 1);
            obj.shadow = shadow;
            disp.push(obj, shadow);
            return obj;
        }
    }, {
        key: "makeDraggable",
        value: function makeDraggable(sprite) {
            var _this5 = this;

            sprite.interactive = true;
            sprite.mousedown = function (e) {
                _this5.dragging = sprite;
                _this5.dragging.inputData = e.data;
            };
            sprite.mouseup = sprite.mouseupoutside = function () {
                console.log("dragXY : " + Math.round(_this5.dragging.x) + ", " + Math.round(_this5.dragging.y));
                _this5.dragging = null;
            };
        }
    }]);

    return SplashScene;
}(p3.Scene);

exports.default = SplashScene;


function createSprite(texture, holder) {
    var sprite = void 0;
    if (typeof texture === "string") sprite = new PIXI.Sprite(_Common2.default.assets.getTexture(texture));else if (texture instanceof PIXI.Texture) sprite = new PIXI.Sprite(texture);
    sprite.anchor = { x: 0.5, y: 0 };
    if (holder) holder.addChild(sprite);
    disp.push(sprite);
    return sprite;
}

},{"./Common":6}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Main
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 19/9/2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Application = require("./Application");

var _Application2 = _interopRequireDefault(_Application);

var _AudioManager = require("./AudioManager");

var _AudioManager2 = _interopRequireDefault(_AudioManager);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _PreloaderScene = require("./PreloaderScene");

var _PreloaderScene2 = _interopRequireDefault(_PreloaderScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//import Physics          from "./Physics";

var Main = function () {
    /**
     * @param {number} width
     * @param {number} height
     */
    function Main(width, height) {
        _classCallCheck(this, Main);

        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {PreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;

        /**
         * so can start game from preloader button
         * @type {Main.startGame}
         */
        window.startGame = this.startGame;
    }

    _createClass(Main, [{
        key: "init",
        value: function init() {

            _Common2.default.assets = p3.AssetManager.instance;
            _Common2.default.audio = p3.Button.audio = new _AudioManager2.default();
            _Common2.default.language = language;

            // Common.physics = new Physics();
            _Common2.default.loadGame();

            var params = new p3.ViewParams();
            params.holderId = "game";
            params.width = this._width;
            params.height = this._height;
            //  params.portrait = true;
            ///params.aspectRatioFillHeight = false;
            params.rotateImageUrl = "./assets/images/localisation/rotate_" + _Common2.default.language + ".jpg";
            params.rotateImageColor = "#000000";

            PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
            PIXI.settings.MIPMAP_TEXTURES = false;

            p3.Device.init(window["bowser"]);

            TweenMax.defaultOverwrite = "none";
            TweenMax.ticker.fps(60);

            var view = new p3.View(params);
            view.signals.ready.addOnce(function (canvas) {
                var options = {};
                options.view = canvas;
                options.transparent = false;
                options.antialias = false;
                options.preserveDrawingBuffer = false;
                options.resolution = 1.0;

                var stage = new PIXI.Container();
                _Common2.default.stage = stage;

                //const input = new Input();
                //input.init(stage, canvas);
                //Common.input = input;

                //on clicking the document focus on canvas, fix for buttons not working on mobile
                document.onclick = function () {
                    canvas.focus();
                };

                if (p3.Device.isCocoonJS) {
                    stage.scale.x = window.innerHeight / params.height;
                    stage.scale.y = window.innerHeight / params.height;
                }

                var renderer = !p3.Device.isCocoonJS ? PIXI.autoDetectRenderer(this._width, this._height, options) : new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
                renderer.backgroundColor = 0x000000;
                _Common2.default.renderer = renderer;
                _Common2.default.isWebGL = renderer instanceof PIXI.WebGLRenderer;

                var scene = new p3.SceneManager(renderer);
                scene.updateAll = true;
                _Common2.default.scene = scene;
                _Common2.default.stage.addChild(scene.view);

                PIXI.ticker.shared.add(function (deltaTime) {

                    window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                    renderer.render(_Common2.default.stage);
                    scene.update();
                }, this);

                /*
                 const timestep = new p3.Timestep(p3.Timestep.FIXED);
                 timestep.init(this.update, this.render, this);
                 Common.timestep = timestep;
                 */

                window.delay = function (callback, delay, scope) {
                    //return Common.animator.setTimeout(callback, delay, scope);
                    TweenMax.delayedCall(delay, callback, [], scope);
                };
                window.translate = function (str) {
                    var s = _Common2.default.config.strings[str];
                    s = s && s[_Common2.default.language];
                    return typeof s !== "undefined" ? s : str;
                };

                this.loadPreloader();
            }, this);
            view.signals.resize.add(this.onCanvasResize, this);
            _Common2.default.view = view;
        }
    }, {
        key: "loadPreloader",
        value: function loadPreloader() {
            var files = [{ name: "preloader", url: "images/" + "preloader" + ".json" }];

            if (_Common2.default.language == 'es') {
                files.push({ name: "preloader_es", url: "images/localisation/preloader_es.png" });
                files.push({ name: "preloader_overlay_es", url: "images/preloader_overlay_es.png" });
            }

            var sounds = [];
            if (files.length) {
                _Common2.default.assets.addFiles(files, "assets/");
                _Common2.default.assets.signals.complete.addOnce(function () {
                    this.createConfig();
                    this.loadAssets();
                }, this);
                _Common2.default.assets.load();
                _Common2.default.audio.addSounds(sounds, [".mp3", ".ogg"], "");
            } else {
                this.loadAssets();
            }
        }
    }, {
        key: "loadAssets",
        value: function loadAssets() {
            var files = [
            //jpeg
            { name: "bg", url: "images/" + "bg" + ".jpg" },
            //spine
            { name: "stunt_happo_flying", url: "images/" + "stunt_happo_flying" + ".json" }, { name: "stunt_happo_standing", url: "images/" + "stunt_happo_standing" + ".json" }, { name: "alien", url: "images/" + "alien" + ".json" }, { name: "tutorial", url: "images/" + "tutorial" + ".json" },
            //png
            { name: "particle", url: "images/" + "particle" + ".png" },
            //  {name: "finger", url: "images/" + "finger" + ".png"},
            //temp single textures
            //   {name: "ground", url: "images/" + "ground" + ".png"},
            ///    {name: "mid_ground", url: "images/" + "mid_ground" + ".png"},
            ///    {name: "mid_ground_2", url: "images/" + "mid_ground_2" + ".png"},
            //     {name: "mountains_bg", url: "images/" + "mountains_bg" + ".png"},
            //sheets
            { name: "ui_1x_0", url: "images/" + "ui_1x_0" + ".json" },
            // {name: "ui_1x_1", url: "images/" + "ui_1x_1" + ".json"},
            { name: "ingame_1x_0", url: "images/" + "ingame_1x_0" + ".json" }, { name: "ingame_1x_1", url: "images/" + "ingame_1x_1" + ".json" }, { name: "bg_assets_1x", url: "images/" + "bg_assets_1x" + ".json" },
            //fonts
            { name: "titles", url: "fonts/" + "titles" + ".xml" }, { name: "copyFoo", url: "fonts/" + "copy" + ".xml" },
            //data
            { name: "copy", url: "data/" + "copy" + ".json" },
            //{name: "config", url: "data/" + "config" + ".json"},
            //particles
            { name: "particles_gameover", url: "particles/" + "particles_gameover" + ".json" }, { name: "particles_dust_ground", url: "particles/" + "particles_dust_ground" + ".json" }, { name: "particles_character_boost_ready", url: "particles/" + "particles_character_boost_ready" + ".json" }, {
                name: "particle_cannon_directional_blast",
                url: "particles/" + "particle_cannon_directional_blast" + ".json"
            }, { name: "particles_splash_mud", url: "particles/" + "particles_splash_mud" + ".json" }, { name: "particles_splash_water", url: "particles/" + "particles_splash_water" + ".json" }, { name: "particles_cannon_1", url: "particles/" + "particles_cannon_1" + ".json" }, { name: "particles_cannon_2", url: "particles/" + "particles_cannon_2" + ".json" }, { name: "particles_pickup", url: "particles/" + "particles_pickup" + ".json" }, { name: "particles_boostmeter", url: "particles/" + "particles_boostmeter" + ".json" }, { name: "particles_boost", url: "particles/" + "particles_boost" + ".json" }];

            var sounds = ["sfx_btn_press_00", "sfx_btn_rollover_00",

            // "sfx_bounce_placeholder",
            "music_mainmenu_loop_00", "music_ready_loop_012", "music_results_short_00", "music_results_long_00",

            //sfx in game
            "sfx_happo_crash_00", "sfx_happo_fling_00", "sfx_happo_fling_01", "sfx_bounce_big_00", "sfx_bounce_bonus_00", "sfx_happos_ooh_00", "sfx_happos_cheer_00", "sfx_happo_impact_00", "sfx_cannon_fire_00", "sfx_cannon_fire_01", "sfx_cannon_move_00", "sfx_cannon_move_01", "sfx_cannon_move_02", "sfx_bounce_bucket_00", "sfx_bounce_drum_00", "sfx_bounce_fear_00", "sfx_bounce_hammock_00", "sfx_bounce_metal_00", "sfx_bounce_plastic_00", "sfx_bounce_springboard_00", "sfx_bounce_trampoline_00", "sfx_bounce_yogaball_00", "sfx_happo_ok_00", "sfx_star_jump_ready_00", "sfx_star_pickup_00", "sfx_bounce_puddle_00", "sfx_bounce_mud_00", "sfx_ambient_desert_loop_00"];
            if (files.length) {
                this._preloader = new _PreloaderScene2.default();
                _Common2.default.scene.add(this._preloader);

                _Common2.default.assets.addFiles(files, "assets/");
                _Common2.default.assets.signals.progress.add(this.onLoadingProgress, this);
                _Common2.default.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
                _Common2.default.assets.load();
                _Common2.default.audio.addSounds(sounds, [".m4a", ".mp3", ".ogg"], "assets/audio/");
            } else {
                this.startGame();
            }
        }
    }, {
        key: "createConfig",
        value: function createConfig() {
            var assets = _Common2.default.assets;
            var config = {};
            _Common2.default.config = config;
        }
    }, {
        key: "startGame",
        value: function startGame() {
            delay(function () {
                this._game = new _Application2.default();
                this._game.init();
            }, 1.0, this);
        }
    }, {
        key: "onLoadingProgress",
        value: function onLoadingProgress(event) {
            this._preloader.loaded = event.progress / 100.0;
        }
    }, {
        key: "onLoadingCompleted",
        value: function onLoadingCompleted() {
            _Common2.default.assets.signals.progress.removeAll();
            _Common2.default.assets.signals.complete.removeAll();

            this._preloader.loaded = 1;
            this.startGame();
        }

        /**
         * @param {boolean} correct
         */

    }, {
        key: "onCanvasResize",
        value: function onCanvasResize(correct) {
            if (correct) {
                _Common2.default.renderer.resize(p3.View.width, p3.View.height);
                if (_Common2.default.scene) {
                    _Common2.default.scene.resize();
                }
            }
        }
    }]);

    return Main;
}();

/**
 *
 * @param copy
 * @param fontName
 * @param size
 * @param holder
 * @param colour
 * @returns {PIXI.Text}
 */


exports.default = Main;
function createText(copy, fontName, size, holder, colour) {
    var col = colour | 0x000000;
    var textView = new PIXI.Text(copy, { fontFamily: fontName, fontSize: size, fill: col });
    textView.anchor.x = 0.5;
    if (holder) holder.addChild(textView);
    //Common.displayObjs.push(textView);
    return textView;
}
window.p3.simpleText = createText;

window.Main = Main;

},{"./Application":2,"./AudioManager":3,"./Common":6,"./PreloaderScene":8}]},{},[11])

